webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(10);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _main = __webpack_require__(23);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _main3 = __webpack_require__(19);
	
	var _main4 = _interopRequireDefault(_main3);
	
	var _main5 = __webpack_require__(15);
	
	var _main6 = _interopRequireDefault(_main5);
	
	var _main7 = __webpack_require__(16);
	
	var _main8 = _interopRequireDefault(_main7);
	
	var _main9 = __webpack_require__(17);
	
	var _main10 = _interopRequireDefault(_main9);
	
	var _main11 = __webpack_require__(21);
	
	var _main12 = _interopRequireDefault(_main11);
	
	var _main13 = __webpack_require__(14);
	
	var _main14 = _interopRequireDefault(_main13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.config.delimiters = ['[[', ']]'];
	_vue2.default.use(_vueRouter2.default);
	
	// generic global components
	
	
	// route specific components
	
	
	var routes = [{
	  path: '/',
	  name: 'home',
	  component: _main8.default
	}, {
	  path: '/map',
	  name: 'map',
	  component: _main10.default
	}, {
	  path: '/map/:modal',
	  name: 'mapModal',
	  component: _main10.default
	}, {
	  path: '/videos/:id/:time',
	  name: 'videos',
	  component: _main12.default
	}, {
	  path: '/videos/:id',
	  name: 'videos',
	  component: _main12.default
	}, {
	  path: '/about',
	  name: 'about',
	  component: _main14.default
	}];
	
	var router = new _vueRouter2.default({ routes: routes });
	
	router.beforeEach(function (to, from, next) {
	  _main2.default.dispatch('routeChange', from);
	  next();
	});
	
	new _vue2.default({
	  el: '#okapp',
	  store: _main2.default,
	  router: router,
	  mounted: function mounted() {
	    var $vm = this;
	    var $body = (0, _jquery2.default)('body');
	    this.$store.dispatch('getContent');
	    if (this.$route.name !== 'home') {
	      this.$store.dispatch('preloaded');
	      this.$store.dispatch('logoAnimated');
	      this.$store.dispatch('showNav');
	    }
	
	    // hacky way to test for touch devices
	    var mouseOverCheck = function mouseOverCheck(e) {
	      if (e.type === 'mouseover') {
	        $vm.$store.dispatch('notTouchDevice');
	      } else if (e.type === 'touchstart') {
	        // do nothing, we have a touch device
	      }
	      $body.off('mouseover touchstart', mouseOverCheck);
	    };
	    $body.on('mouseover touchstart', mouseOverCheck);
	  },
	
	  components: { PreLoader: _main4.default, AudioPlayer: _main6.default },
	  computed: {
	    ui: function ui() {
	      return this.$store.state.ui;
	    },
	    page: function page() {
	      return this.$route.name + '-page';
	    }
	  }
	
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_CONTENT = exports.GET_CONTENT = 'GET_CONTENT';
	
	var ROUTE_CHANGE = exports.ROUTE_CHANGE = 'ROUTE_CHANGE';
	
	var IS_PRELOADING = exports.IS_PRELOADING = 'IS_PRELOADING';
	
	var HAS_PRELOADED = exports.HAS_PRELOADED = 'HAS_PRELOADED';
	
	var HAS_PRELOADED_HALF = exports.HAS_PRELOADED_HALF = 'HAS_PRELOADED_HALF';
	
	var LOGO_ANIMATED = exports.LOGO_ANIMATED = 'LOGO_ANIMATED';
	
	var TOGGLE_CLASS = exports.TOGGLE_CLASS = 'TOGGLE_CLASS';
	
	var SHOW_NAV = exports.SHOW_NAV = 'SHOW_NAV';
	
	var HIDE_NAV = exports.HIDE_NAV = 'HIDE_NAV';
	
	var NOT_TOUCH_DEVICE = exports.NOT_TOUCH_DEVICE = 'NOT_TOUCH_DEVICE';

/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _template = __webpack_require__(29);
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _vue2.default.component('about', {
	  template: _template2.default,
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	    this.$store.dispatch('showNav');
	  },
	
	  computed: {
	    content: function content() {
	      return this.$store.state.content.about || [];
	    }
	  }
	});

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _jsCookie = __webpack_require__(7);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__(30);
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.cook = _jsCookie2.default;
	
	exports.default = _vue2.default.component('audio-player', {
	  template: _template2.default,
	  data: function data() {
	    return {
	      audio: null,
	      btnAnim: null,
	      playing: false,
	      pauseIcon: 'M11,10 L18,13.74 18,22.28 11,26 M18,13.74 L26,18 26,18 18,22.28',
	      playIcon: 'M11,10 L17,10 17,26 11,26 M20,10 L26,10 26,26 20,26'
	    };
	  },
	  mounted: function mounted() {
	    var $vm = this;
	    var $el = (0, _jquery2.default)(this.$el);
	    var audio = $el.find('audio')[0];
	    var btnAnim = $el.find('animate')[0];
	
	    var cookiePlaying = _jsCookie2.default.get('playing');
	
	    audio.addEventListener('loadedmetadata', function () {
	      $vm.audio = audio;
	      $vm.btnAnim = btnAnim;
	
	      audio.currentTime = 8;
	      audio.volume = 0.5;
	
	      audio.addEventListener('play', function () {
	        $vm.playing = true;
	      });
	
	      audio.addEventListener('pause', function () {
	        $vm.playing = false;
	      });
	
	      if (cookiePlaying == '1' || cookiePlaying === undefined) {
	        $vm.togglePlay();
	      }
	    });
	  },
	
	  methods: {
	    togglePlay: function togglePlay() {
	      if (this.playing) {
	        this.audio.pause();
	        _jsCookie2.default.set('playing', 0);
	      } else {
	        this.audio.play();
	        _jsCookie2.default.set('playing', 1);
	      }
	    }
	  }
	});

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _template = __webpack_require__(31);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lory = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapLetters(word) {
	  return word.split('').map(function (char) {
	    return '<span>' + char + '</span>';
	  });
	}
	
	function animateWords(tl, words) {
	  words.forEach(function (word) {
	    word.addClass('blur');
	  });
	}
	
	function animateLetters($vm, tl, letters) {
	  letters.forEach(function (letter) {
	    tl.fromTo(letter, 2, { opacity: 0, y: '+=10' }, { opacity: 1, y: '-=10', onComplete: function onComplete() {
	        $vm.$store.dispatch('logoAnimated');
	        $vm.$store.dispatch('showNav');
	      } }, Math.random());
	  });
	}
	
	function animateHeading($vm, heading) {
	  var words = heading.text().split(' '),
	      wordsArray = [],
	      lettersArray = [],
	      tl = new window.TimelineMax();
	
	  heading.html('');
	
	  words.forEach(function (word, index) {
	    var wordset = (0, _jquery2.default)('<span/>', { id: 'txt' + index }).html(wrapLetters(word)).appendTo(heading);
	    wordsArray.push(wordset);
	    wordset.find('span').each(function (index, letter) {
	      lettersArray.push(letter);
	    });
	  });
	
	  animateWords(tl, wordsArray);
	  animateLetters($vm, tl, lettersArray);
	}
	
	exports.default = _vue2.default.component('heroes', {
	  template: _template2.default,
	  data: function data() {
	    return {
	      randomOrder: _lodash2.default.shuffle([0, 1, 2]),
	      activeIndex: 0,
	      slider: {},
	      textAnimated: false,
	      sliding: false
	    };
	  },
	  watch: {
	    hasPreloaded: function hasPreloaded() {
	      if (!this.logoAnimated) {
	        this.animateLogo(0);
	      }
	    },
	    logoAnimated: function logoAnimated(current) {
	      var $vm = this;
	      if (current) {
	        // every 30seconds next slide
	        setInterval(function () {
	          if (!$vm.sliding) {
	            $vm.slider.next();
	          }
	        }, 20000);
	      }
	    }
	  },
	  mounted: function mounted() {
	    var $vm = this;
	    this.$h2 = (0, _jquery2.default)(this.$el).find('h2').first();
	    this.$img = (0, _jquery2.default)(this.$el).find('.heroes__intro-image');
	
	    if (this.prevRoute) {
	      this.$store.dispatch('logoAnimated');
	      this.$store.dispatch('showNav');
	      this.textAnimated = true;
	      // this.activeIndex = _.random(0,2);
	    }
	
	    _vue2.default.nextTick(function () {
	      var slider = $vm.$el.querySelector('.js_slider');
	
	      $vm.slider = (0, _lory.lory)(slider, {
	        infinite: 1,
	        enableMouseEvents: true
	      });
	      $vm.slider.slideTo($vm.randomOrder[0]);
	      $vm.activeIndex = $vm.randomOrder[0];
	      slider.addEventListener('on.lory.resize', function () {
	        $vm.slider.slideTo($vm.activeIndex);
	      });
	      slider.addEventListener('before.lory.slide', function () {
	        $vm.sliding = true;
	        if ($vm.logoAnimated && !$vm.textAnimated) {
	          window.TweenMax.to($vm.$h2, 0.3, { opacity: 0, onComplete: function onComplete() {
	              setTimeout(function () {
	                $vm.textAnimated = true;
	              }, 1000);
	            } });
	        }
	      });
	      slider.addEventListener('after.lory.slide', function (currentSlide) {
	        setTimeout(function () {
	          $vm.activeIndex = currentSlide.detail.currentSlide - 1;
	          $vm.sliding = false;
	        }, 1000);
	      });
	    });
	  },
	
	  methods: {
	    animateLogo: function animateLogo(step) {
	      var $vm = this;
	      var $img = this.$img;
	      if (step < 283) {
	        setTimeout(function () {
	          window.requestAnimationFrame(function () {
	            var url = location.pathname + 'images/hero-sequence/logo';
	            var num = '0' + step;
	            if (step < 10) {
	              num = '000' + step;
	            } else if (step < 100) {
	              num = '00' + step;
	            }
	            $img.prop('src', url + num + '.png');
	            $vm.animateLogo(step + 1);
	            $vm.animateImages(step + 1);
	          });
	        }, 1000 / 25);
	      } else {
	        this.$img.fadeOut(2000, function () {
	          $vm.$h2.css('display', 'block');
	          animateHeading($vm, $vm.$h2);
	        });
	      }
	    },
	    animateImages: function animateImages(step) {
	      if (step < 100) {
	        // this.activeIndex = this.randomOrder[0];
	        this.slider.slideTo(this.randomOrder[0]);
	      } else if (step > 100 && step < 170) {
	        // this.activeIndex = this.randomOrder[1];
	        this.slider.slideTo(this.randomOrder[1]);
	      } else {
	        // this.activeIndex = this.randomOrder[2];
	        this.slider.slideTo(this.randomOrder[2]);
	      }
	    },
	    showSlide: function showSlide(index) {
	      this.slider.slideTo(index - 1);
	    },
	    prev: function prev() {
	      this.slider.prev();
	    },
	    next: function next() {
	      this.slider.next();
	    }
	  },
	  computed: {
	    hasPreloaded: function hasPreloaded() {
	      return this.$store.state.ui.hasPreloaded;
	    },
	    logoAnimated: function logoAnimated() {
	      return this.$store.state.ui.logoAnimated;
	    },
	    content: function content() {
	      return this.$store.state.content.home || {};
	    },
	    prevRoute: function prevRoute() {
	      return this.$store.state.routes.prevRoute.name;
	    },
	    activeImage: function activeImage() {
	      return this.activeIndex + 1;
	    },
	    activeHeading: function activeHeading() {
	      return this.content.images ? this.content.images[this.activeIndex].heading : '';
	    },
	    prevIndex: function prevIndex() {
	      var images = this.content.images || [];
	      var prev = this.activeIndex - 1;
	      if (prev < 0) {
	        prev = images.length - 1;
	      }
	      return prev;
	    },
	    nextIndex: function nextIndex() {
	      var images = this.content.images || [];
	      var next = this.activeIndex + 1;
	      if (next >= images.length) {
	        next = 0;
	      }
	      return next;
	    },
	    prevTitle: function prevTitle() {
	      return this.content.images ? this.content.images[this.prevIndex].title : '';
	    },
	    nextTitle: function nextTitle() {
	      return this.content.images ? this.content.images[this.nextIndex].title : '';
	    }
	  }
	});

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _template = __webpack_require__(32);
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _vue2.default.component('ok-map', {
	  template: _template2.default,
	  data: function data() {
	    return {
	      timer: false,
	      activeCategory: '',
	      filterCategory: '',
	      activePin: {},
	      showModal: false,
	      modalId: -1
	    };
	  },
	  watch: {
	    ready: function ready() {
	      this.init();
	    },
	    '$route': function $route(to) {
	      if (to.name == 'mapModal' && to.params.modal) {
	        this.openModal({ gid: to.params.modal * 1 });
	      } else {
	        this.showModal = false;
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.prevRoute) {
	      this.init();
	    }
	  },
	
	  methods: {
	    init: function init() {
	      var _this = this;
	      _vue2.default.nextTick(function () {
	        _this.animateMap();
	        setTimeout(function () {
	          _this.handleRoute();
	        }, 1000);
	      });
	    },
	    animateMap: function animateMap() {
	      var interval = 0.075;
	      var $vm = this;
	      var mapTL = new window.TimelineLite();
	      var okinawa = document.getElementById('okinawa');
	      var ishigaki = document.getElementById('ishigaki');
	      var taketomi = document.getElementById('taketomi');
	      var allPins = document.getElementsByClassName('map__pins');
	      var culturePins = document.getElementsByClassName('culturePins');
	      var locationsPins = document.getElementsByClassName('locationsPins');
	      var foodPins = document.getElementsByClassName('foodPins');
	      var naturePins = document.getElementsByClassName('naturePins');
	      var groupPins = document.getElementsByClassName('groupPins');
	      var bgWave = document.getElementsByClassName('map__wave');
	      mapTL.staggerFromTo([okinawa, ishigaki, taketomi], 3, { scale: 0.85, opacity: 0, x: '+=30', y: '-=10' }, { scale: 0.9, opacity: 1 }, interval * 4, 'together').staggerFromTo([groupPins, culturePins, locationsPins, foodPins, naturePins], 3, { y: '-=20', opacity: 0 }, { y: '+=20', opacity: 1 }, 0.1, 'together+=1.2');
	
	      var yoyoX = _lodash2.default.random(20, 40);
	      var yoyoY = _lodash2.default.random(20, 40);
	      window.TweenMax.to(bgWave, interval * 36 * 2, { x: '+=' + yoyoX, y: '+=' + yoyoY, opacity: '-=0.2', repeat: -1, yoyo: true, ease: window.Linear.easeNone });
	
	      this.$store.dispatch('showNav');
	
	      // Pin group modal location update
	      window.onresize = function () {
	        if ($vm.activePin.target) {
	          var bounds = $vm.activePin.target.getBoundingClientRect();
	          $vm.activePin.x = bounds.left;
	          $vm.activePin.y = bounds.top;
	        }
	      };
	
	      // Pin hover animations
	      _lodash2.default.each(allPins, function (pin) {
	        window.TweenMax.set([pin], { transformOrigin: '50% 100%' });
	        pin.addEventListener('mouseenter', _lodash2.default.debounce(function () {
	          $vm.activePin = {};
	          window.TweenMax.to([pin], 0.3, { scale: 1.2, ease: window.Linear.easeNone });
	        }, 20));
	        pin.addEventListener('mouseleave', _lodash2.default.debounce(function () {
	          window.TweenMax.to([pin], 0.3, { scale: 1, ease: window.Linear.easeNone });
	        }, 20));
	      });
	    },
	    showGroup: function showGroup(group, event) {
	      window.evt = event;
	      var bounds = document.getElementById('group_marker_' + group.id).getBoundingClientRect();
	
	      this.activePin = {
	        id: group.id,
	        show: true,
	        bounds: bounds,
	        x: bounds.left,
	        y: bounds.top
	      };
	
	      window.dataLayer.push({
	        'event': 'groupPinClick'
	      });
	    },
	    playVideo: function playVideo(pin) {
	      this.trackModal(pin);
	      this.$router.push({
	        name: 'videos',
	        params: {
	          id: pin.section.video,
	          time: pin.section.time
	        }
	      });
	    },
	    setCategory: function setCategory(cat) {
	      var $pins = (0, _jquery2.default)('.map__pins').not('.groupPins');
	      // let $groups = $('.groupPins');
	
	      if (cat) {
	        var $hidePins = $pins.not('.' + cat);
	        var $showPins = $pins.filter('.' + cat);
	        window.TweenMax.set([$hidePins, $showPins], { transformOrigin: '50% 100%' });
	        window.TweenMax.to($hidePins, 1, { scale: 0.5, opacity: 0, ease: window.Linear.easeOut });
	        window.TweenMax.to($showPins, 1, { scale: 1, opacity: 1, ease: window.Linear.easeOut });
	        this.activePin = {};
	      } else {
	        window.TweenMax.to($pins, 1, { scale: 1, opacity: 1, ease: window.Linear.easeOut });
	      }
	      this.activeCategory = cat;
	      this.filterCategory = cat.split('P')[0];
	    },
	    toggleCategory: function toggleCategory(cat) {
	      if (this.activeCategory == cat) {
	        this.activeCategory = '';
	      } else {
	        this.activeCategory = cat;
	      }
	    },
	    openModal: function openModal(pin) {
	      this.showModal = true;
	      this.activePin = {};
	      this.modalId = pin.gid;
	      this.$router.push({ name: 'mapModal', params: { modal: pin.gid } });
	      this.trackModal(pin);
	    },
	
	    closeModal: function closeModal() {
	      this.showModal = false;
	      this.$router.push({ name: 'map' });
	    },
	    handlePopup: function handlePopup(pin) {
	      if (pin.section) {
	        this.playVideo(pin);
	      } else {
	        this.openModal(pin);
	      }
	    },
	    handleRoute: function handleRoute() {
	      if (this.$route.params.modal) {
	        this.openModal({ gid: this.$route.params.modal * 1 });
	      }
	    },
	    getContentCategory: function getContentCategory(category) {
	      return _lodash2.default.filter(this.content, { category_class: category });
	    },
	    trackModal: function trackModal(pin) {
	      if (pin.title) {
	        window.dataLayer.push({
	          'event': 'pinClick',
	          'name': pin.title,
	          'category': pin.category,
	          'type': pin.section ? 'video' : 'content'
	        });
	      }
	    }
	  },
	  computed: {
	    prevRoute: function prevRoute() {
	      return this.$store.state.routes.prevRoute.name;
	    },
	    content: function content() {
	      return this.$store.state.content.details || [];
	    },
	    groupMarkers: function groupMarkers() {
	      return this.$store.state.content.groups || [];
	    },
	    filteredGroups: function filteredGroups() {
	      return this.filterCategory ? _lodash2.default.filter(this.content, { category_class: this.filterCategory }) : this.content;
	    },
	    groupPins: function groupPins() {
	      return _lodash2.default.groupBy(_lodash2.default.filter(this.filteredGroups, 'group'), 'group.id');
	    },
	    nonGroups: function nonGroups() {
	      return _lodash2.default.reject(this.content, 'group');
	    },
	    modals: function modals() {
	      return _lodash2.default.reject(this.content, 'section');
	    },
	    videoPins: function videoPins() {
	      return _lodash2.default.filter(this.nonGroups, 'section');
	    },
	    nonVideoPins: function nonVideoPins() {
	      return _lodash2.default.reject(this.nonGroups, 'section');
	    },
	    naturePins: function naturePins() {
	      return _lodash2.default.filter(this.nonVideoPins, { category: 'nature' });
	    },
	    culturePins: function culturePins() {
	      return _lodash2.default.filter(this.nonVideoPins, { category: 'culture' });
	    },
	    foodPins: function foodPins() {
	      return _lodash2.default.filter(this.nonVideoPins, { category: 'food & drink' });
	    },
	    locationsPins: function locationsPins() {
	      return _lodash2.default.filter(this.nonVideoPins, { category: 'locations' });
	    },
	    videoNaturePins: function videoNaturePins() {
	      return _lodash2.default.filter(this.videoPins, { category: 'nature' });
	    },
	    videoCulturePins: function videoCulturePins() {
	      return _lodash2.default.filter(this.videoPins, { category: 'culture' });
	    },
	    videoFoodPins: function videoFoodPins() {
	      return _lodash2.default.filter(this.videoPins, { category: 'food & drink' });
	    },
	    videoLocationsPins: function videoLocationsPins() {
	      return _lodash2.default.filter(this.videoPins, { category: 'locations' });
	    },
	    hasPreloaded: function hasPreloaded() {
	      return this.$store.state.ui.hasPreloaded;
	    },
	    ready: function ready() {
	      if (this.content.length && this.hasPreloaded) {
	        return true;
	      }
	      return false;
	    }
	  }
	});

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _hammerjs = __webpack_require__(6);
	
	var _hammerjs2 = _interopRequireDefault(_hammerjs);
	
	var _template = __webpack_require__(33);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _lory = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _vue2.default.component('modal', {
	  template: _template2.default,
	  data: function data() {
	    return {
	      currentSlide: 0,
	      slider: undefined,
	      showSocials: false
	    };
	  },
	
	  props: ['modal', 'isActive', 'closeModal'],
	  watch: {
	    isActive: function isActive() {
	      var $vm = this;
	      setTimeout(function () {
	        $vm.setupSlider();
	      }, 1000);
	    }
	  },
	  mounted: function mounted() {
	    var $vm = this;
	    var hammertime = new _hammerjs2.default(this.$el);
	    hammertime.on('swiperight', function (ev) {
	      if (ev.target.nodeName !== 'IMG') {
	        $vm.closeThisModal();
	      }
	    });
	    if (window.addthis && window.addthis.toolbox) {
	      window.addthis.toolbox((0, _jquery2.default)(this.$el).find('.addthis_toolbox')[0]);
	    }
	  },
	
	  methods: {
	    slideTo: function slideTo(index) {
	      this.slider.slideTo(index);
	    },
	    setupSlider: function setupSlider() {
	      var slider = (0, _jquery2.default)(this.$el).find('.js_slider')[0];
	      var $vm = this;
	      $vm.slider = (0, _lory.lory)(slider, {
	        infinite: 1,
	        enableMouseEvents: true
	      });
	
	      slider.addEventListener('after.lory.slide', function (currentSlide) {
	        $vm.currentSlide = currentSlide.detail.currentSlide - 1;
	      });
	    },
	    closeThisModal: function closeThisModal() {
	      this.closeModal();
	    }
	  },
	  computed: {
	    categoryClass: function categoryClass() {
	      return this.modal.category.toString().split('&')[0].trim();
	    }
	  }
	});

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _waves = __webpack_require__(20);
	
	var _waves2 = _interopRequireDefault(_waves);
	
	var _template = __webpack_require__(34);
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _vue2.default.component('pre-loader', {
	  template: _template2.default,
	  data: function data() {
	    return {};
	  },
	  watch: {
	    hasPreloadedHalf: function hasPreloadedHalf() {
	      window.TweenMax.fromTo((0, _jquery2.default)('.pre-loader__text'), 7, { scale: 0.7, opacity: 0 }, { scale: 1, opacity: 1, ease: window.Linear.easeOut });
	    }
	  },
	  mounted: function mounted() {
	    if (!this.hasPreloaded) {
	      (0, _waves2.default)(this.$el, this.$store).init();
	    } else {
	      (0, _jquery2.default)(this.$el).fadeOut(1000);
	    }
	  },
	
	  computed: {
	    hasPreloaded: function hasPreloaded() {
	      return this.$store.state.ui.hasPreloaded;
	    },
	    hasPreloadedHalf: function hasPreloadedHalf() {
	      return this.$store.state.ui.hasPreloadedHalf;
	    }
	  }
	});

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _paper = __webpack_require__(8);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (container, $store) {
	  var $container = (0, _jquery2.default)(container);
	  var canvas = $container.find('canvas')[0];
	  var $canvas = (0, _jquery2.default)(canvas);
	  var screenRation = window.innerHeight / window.innerWidth;
	  var fadeOutPoint = screenRation > 1 ? 200 : 150; // portrait vs landscape
	  // console.log('fadeout pointer',fadeOutPoint);
	  _paper2.default.setup(canvas);
	
	  // global paper view object
	  var paperView = _paper2.default.view;
	  // let drainFactor = $document.innerHeight()*0.005;
	
	  // container for all wave paths created;
	  var paths = [];
	  var queue = void 0;
	  var progress = 0;
	
	  var preloaded = false;
	
	  function loadAssets() {
	    var queue = new window.createjs.LoadQueue();
	    var items = [];
	
	    // logo animation
	    for (var i = 0; i < 283; i++) {
	      var url = window.location.pathname + 'images/hero-sequence/logo';
	      var num = '0' + i;
	      if (i < 10) {
	        num = '000' + i;
	      } else if (i < 100) {
	        num = '00' + i;
	      }
	
	      items.push({
	        src: url + num + '.png'
	      });
	    }
	    queue.loadManifest(items, false);
	
	    queue.on('progress', function () {
	      setTimeout(function () {
	        progress = queue.progress;
	      }, 300);
	    });
	
	    return queue;
	  }
	
	  function createPath(options) {
	    var path = new _paper2.default.Path({
	      fillColor: options.fillColor
	    });
	    var center = paperView.center;
	    var width = paperView.size.width;
	
	    // container for all Points
	    path.segments = [];
	    // bind path to bottom left of screen
	    path.add(paperView.bounds.bottomLeft);
	
	    for (var i = 0; i < options.points; i++) {
	      var point = new _paper2.default.Point(width / (options.points - 1) * i, center.y);
	      path.add(point);
	    }
	
	    // bind path to bottom right of screen
	    path.add(paperView.bounds.bottomRight);
	
	    // scale to smooth overall shape off the screen edges
	    path.scale(2);
	
	    // blend if required
	    // path.blendMode = options.blendMode;
	
	    // Select the path, so we can see how it is constructed:
	    // path.fullySelected = true;
	
	    // save for later use in animation
	    path.options = options;
	    return path;
	  }
	
	  function animateWaves(event, path) {
	    var length = path.segments.length;
	    // i offsets from first and last to avoid animating the bottom left
	    // and bottom right anchor points
	    for (var i = 1; i < length - 1; i++) {
	      var segment = path.segments[i];
	      // Sin a cylic value between -1 and 1
	      // first sin creates the wave form
	      var sine = Math.sin(event.time * 2 + i * path.options.waveDirection);
	      // cosin creates the y axis oscilation
	      var cosine = Math.cos(1 / event.time * 2 + i);
	      // Change the y position of the segment point, keep it in middle of the view
	      segment.point.y = sine * path.options.waveHeight * cosine + paperView.center.y;
	    }
	    // smooth the path
	    path.smooth({
	      type: 'continuous'
	    });
	  }
	  // let oldTop = $canv
	  function drainWater(loadPercent) {
	    $canvas.css('margin-top', loadPercent + '%');
	  }
	
	  function getWaveHeight() {
	    var base = 20;
	    if (window.outerWidth > 700) {
	      base = 40;
	    }
	    if (window.outerWidth > 1200) {
	      base = 60;
	    }
	    return base;
	  }
	
	  // initialiation routine
	  function init() {
	    // add loading
	    $store.dispatch('preloading');
	    queue = loadAssets();
	    queue.load();
	
	    // on resize we need to kill old paths and recreate
	    if (paths.length) {
	      paths.forEach(function (path) {
	        path.remove();
	        paperView.update();
	      });
	    }
	
	    var waveHeight = getWaveHeight();
	
	    // initial waves options
	    var waves = [{
	      points: 8,
	      fillColor: 'rgba(221,247,251, 1)',
	      waveHeight: waveHeight, //viewRatio * waveFactor, //60,
	      // blendMode: 'normal',
	      waveDirection: 1
	    }, {
	      points: 5,
	      fillColor: 'rgba(196,237,239, 0.8)',
	      waveHeight: waveHeight * 2, //viewRatio * waveFactor * 2, //120,
	      // blendMode: 'normal',
	      waveDirection: -1
	    }];
	
	    // create new paths from waves template
	    waves.forEach(function (wave) {
	      paths.push(createPath(wave));
	    });
	
	    // ready for showing
	    //
	
	    // this is a safety catch, if we are still here when the frame bellow
	    // stops then fade out the preloader and move on
	    paperView.on('frame', _lodash2.default.debounce(function () {
	      // console.log('final frame');
	      $container.fadeOut(5000);
	      $store.dispatch('preloaded');
	    }, 1000));
	  }
	
	  // View event methods ///////////////////////////////////////////////////////
	
	  // triggers on canvas rsize
	  paperView.on('resize', function () {
	    setTimeout(function () {
	      init();
	    }, 100);
	  });
	
	  // triggers 60 frames per second
	  paperView.onFrame = function (event) {
	    window.evt = event;
	    var loaded = Math.floor(progress * 20);
	    var time = Math.floor(event.time * 10);
	    var drainDown = time - loaded;
	    // Loop through the segments of the path:
	    // console.log('time:',time, ' | loaded:', loaded, ' | drain:',drainDown);
	    if (paths.length) {
	      paths.forEach(function (path) {
	        animateWaves(event, path);
	      });
	      // drainWater();
	      // var percetage = queue.progress;
	      if (drainDown > fadeOutPoint && progress == 1 && !preloaded) {
	        // drainWater(1);
	        $container.fadeOut(5000);
	        $store.dispatch('preloaded');
	        // $('.container').addClass('ready'); // temporary, move to VUEX state management
	        preloaded = true;
	      } else {
	        if (drainDown > 50) {
	          $store.dispatch('preloadedHalf');
	        }
	        drainWater(drainDown);
	      }
	    }
	  };
	
	  /////////////////////////////////////////////////////////////////////////////
	
	  // expose methods
	  return {
	    init: init
	  };
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _template = __webpack_require__(35);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _main = __webpack_require__(18);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.$ = _jquery2.default;
	
	exports.default = _vue2.default.component('videos', {
	  template: _template2.default,
	  data: function data() {
	    return {
	      progress: 0,
	      duration: 0,
	      currentVideo: {},
	      currentTime: 0,
	      modalTime: 0,
	      noPrompt: false,
	      showModal: false,
	      barWidth: 0,
	      videoDuration: 0,
	      videoPlaying: false,
	      videoEnded: false,
	      video: false,
	      ytPlayer: undefined,
	      windowWidth: window.outerWidth,
	      otherVideos: [],
	      hintPoint: false
	    };
	  },
	  watch: {
	    videos: function videos(_videos) {
	      if (_videos && _videos.length) {
	        this.updateCurrentVideo();
	      }
	    },
	    videoId: function videoId(current) {
	      var _this = this;
	
	      if (current) {
	        (function () {
	          var $vm = _this;
	          setTimeout(function () {
	            $vm.otherVideos = $vm.getOtherVideos();
	          }, 3000);
	        })();
	      }
	    },
	    hasPreloaded: function hasPreloaded() {
	      if (this.hasPreloaded) {
	        this.init();
	      }
	    },
	    currentTime: function currentTime(current) {
	      var match = false;
	      this.modalTimes.forEach(function (time) {
	        if (current >= time && current < time + 10) {
	          match = true;
	        }
	      });
	      this.hintPoint = match;
	    },
	    '$route': function $route(to, from) {
	      if (to.name.match('videos')) {
	        if (from.params.id != to.params.id) {
	          this.updateCurrentVideo();
	        } else if (to.params.time) {
	          this.showModalAt(to.params.time * 1);
	        }
	      } else {
	        this.showModal = false;
	      }
	    }
	  },
	  components: { Modal: _main2.default },
	  mounted: function mounted() {
	    var $vm = this;
	    var iframe = this.$el.getElementsByTagName('iframe')[0];
	    this.iframe = iframe;
	    this.barWidth = (0, _jquery2.default)('.videos__progress').prop('offsetWidth');
	    this.otherVideos = $vm.getOtherVideos();
	    this.updateCurrentVideo();
	
	    if (this.prevRoute) {
	      this.init();
	    }
	  },
	
	  methods: {
	    init: function init() {
	      var _this2 = this;
	
	      var $vm = this;
	      if (_lodash2.default.isObject(window.YT) && _lodash2.default.isObject(window.YT.Player)) {
	        (function () {
	          var ytPlayer = new window.YT.Player(_this2.iframe, {
	            events: {
	              'onReady': function onReady() {
	                $vm.playerSetup(ytPlayer);
	              }
	            }
	          });
	
	          (0, _jquery2.default)('.videos__playpause').on('mousemove', _lodash2.default.debounce(function () {
	            $vm.peekUI();
	          }, 50));
	
	          (0, _jquery2.default)('.videos__playpause').on('click', function () {
	            $vm.togglePlayPause();
	          });
	        })();
	      } else {
	        setTimeout(this.init, 1000);
	      }
	    },
	    playerSetup: function playerSetup(ytPlayer) {
	      var $vm = this;
	      this.ytPlayer = ytPlayer;
	      this.currentVideo.duration = ytPlayer.getDuration();
	      if (this.$route.params.time) {
	        this.showModalAt(this.$route.params.time * 1);
	        this.currentVideo.furthestTime = this.$route.params.time * 1;
	      } else {
	        if ($vm.currentVideo.seenPrompt) {
	          $vm.handlePlay();
	        } else {
	          setTimeout(function () {
	            $vm.handlePlay();
	          }, 3000);
	        }
	      }
	
	      this.monitorPlayerStateChange();
	    },
	    monitorPlayerStateChange: function monitorPlayerStateChange() {
	      var $vm = this;
	      var timer = setInterval(function () {
	        if ($vm.ytPlayer) {
	          var state = $vm.ytPlayer.getPlayerState();
	          if (state == 1) {
	            // playing state
	            $vm.updateTime();
	            $vm.videoEnded = false;
	            $vm.videoPlaying = true;
	            if ($vm.isTouchDevice && $vm.showNav) {
	              $vm.showModal = false;
	              // $vm.$store.dispatch('hideNav');
	            }
	          } else if (state == 2) {
	            // paused state
	            $vm.videoPlaying = false;
	            $vm.$store.dispatch('showNav');
	          } else if (state == 0) {
	            // paused state
	            $vm.videoPlaying = false;
	            $vm.videoEnded = true;
	            $vm.$store.dispatch('showNav');
	          }
	        }
	
	        if (!$vm.$route.name.match('videos')) {
	          window.clearInterval(timer);
	        }
	      }, 1000);
	    },
	    updateTime: function updateTime() {
	      var ytPlayer = this.ytPlayer;
	      var currentTime = ytPlayer.getCurrentTime();
	      var currentVideo = this.currentVideo || {};
	      this.currentTime = currentTime;
	      currentVideo.furthestTime = Math.max(currentTime, currentVideo.furthestTime || 0);
	    },
	    updateCurrentVideo: function updateCurrentVideo() {
	      if (this.videos && this.videos.length) {
	        this.currentVideo = _lodash2.default.find(this.videos, { id: this.$route.params.id * 1 });
	        this.introPrompt();
	      }
	    },
	
	    // this video info modal was added last minite, logic could be better placed
	    // but its the 11th hour. しょうがない
	    introPrompt: function introPrompt() {
	      var $vm = this;
	      if (!this.$route.params.time) {
	        if (!$vm.currentVideo.seenPrompt) {
	          // $vm.$store.dispatch('hideNav');
	          setTimeout(function () {
	            $vm.currentVideo.seenPrompt = true;
	          }, 6000);
	        }
	      } else {
	        $vm.noPrompt = true;
	      }
	    },
	    peekUI: function peekUI() {
	      var $vm = this;
	      if (!this.showNav && this.videoPlaying) {
	        this.$store.dispatch('showNav');
	        window.clearTimeout(this.peekingTimer);
	        this.peekingTimer = setTimeout(function () {
	          if ($vm.videoPlaying) {
	            $vm.handleHideNav();
	          }
	        }, 3000);
	      }
	    },
	    togglePlayPause: function togglePlayPause() {
	      var state = this.ytPlayer.getPlayerState();
	      if (state == 1) {
	        this.ytPlayer.pauseVideo();
	      } else {
	        // this.ytPlayer.playVideo();
	        this.showModal = false;
	        this.handlePlay();
	      }
	    },
	    closeModal: function closeModal() {
	      this.showModal = false;
	      // this.ytPlayer.playVideo();
	      this.handlePlay();
	    },
	    openModal: function openModal(pin, hotspot) {
	      // this.showModal = true;
	      // this.modalTime = pin.section.time;
	      // this.currentTime = pin.section.time;
	
	      if (hotspot) {
	        this.showHotspotModal(pin.section.time);
	        this.trackModal(pin, '-hotspot');
	      } else {
	        this.showModalAt(pin.section.time);
	        this.trackModal(pin, '-timeline');
	      }
	    },
	    showHotspotModal: function showHotspotModal(time) {
	      this.ytPlayer.pauseVideo();
	      this.showModal = true;
	      this.modalTime = time;
	      this.currentTime = time;
	      this.$router.push({
	        name: 'videos',
	        params: {
	          id: this.$route.params.id,
	          time: time
	        }
	      });
	    },
	    showModalAt: function showModalAt(time) {
	      var $vm = this;
	      $vm.ytPlayer.seekTo(time, true);
	      $vm.modalTime = time;
	      $vm.currentTime = time;
	      $vm.showModal = true;
	      $vm.$store.dispatch('showNav');
	
	      if (!this.isTouchDevice) {
	        $vm.ytPlayer.playVideo();
	        setTimeout(function () {
	          $vm.ytPlayer.pauseVideo();
	        }, 1300);
	      } else {
	        this.ytPlayer.pauseVideo();
	      }
	
	      this.$router.push({
	        name: 'videos',
	        params: {
	          id: this.$route.params.id,
	          time: time
	        }
	      });
	    },
	    timePercentage: function timePercentage(time) {
	      return Math.floor(time / this.currentVideo.duration * 100);
	    },
	    timeToOffset: function timeToOffset(time) {
	      var xpos = -100;
	      if (this.ytPlayer) {
	        xpos = this.timePercentage(time);
	      }
	      return xpos + '%';
	    },
	    scrobble: function scrobble(evt) {
	      var parentWidth = (0, _jquery2.default)('.videos__progress').prop('offsetWidth');
	      var xpos = evt.offsetX;
	      var time = Math.floor(xpos / parentWidth * this.currentVideo.duration);
	      this.ytPlayer.seekTo(time, true);
	    },
	    handlePlay: function handlePlay() {
	      var $vm = this;
	      // let isTouch = this.isTouchDevice;
	      if (!this.isTouchDevice || this.windowWidth > 1020) {
	        this.ytPlayer.playVideo();
	        setTimeout(function () {
	          $vm.handleHideNav();
	        }, 5000);
	      }
	    },
	    handleHideNav: function handleHideNav() {
	      if (this.$route.name.match('videos') && !this.showModal) {
	        this.$store.dispatch('hideNav');
	      }
	    },
	    replayVideo: function replayVideo() {
	      this.ytPlayer.seekTo(1, true);
	      this.$router.push('/videos/' + this.currentVideo.id);
	      this.handlePlay();
	    },
	    getOtherVideos: function getOtherVideos() {
	      var $vm = this;
	      return _lodash2.default.filter(this.videos, function (video) {
	        return video.id !== $vm.currentVideo.id;
	      });
	    },
	    trackModal: function trackModal(pin, type) {
	      if (pin.title) {
	        window.dataLayer.push({
	          'event': 'videoNav' + type,
	          'name': pin.title,
	          'category': pin.category,
	          'videoId': pin.section.video,
	          'videoTitle': this.currentVideo.title,
	          'videoTimePoint': pin.section.time
	        });
	      }
	    }
	  },
	  computed: {
	    prevRoute: function prevRoute() {
	      return this.$store.state.routes.prevRoute.name;
	    },
	    videos: function videos() {
	      return this.$store.state.content.videos;
	    },
	    details: function details() {
	      return this.$store.state.content.details || [];
	    },
	
	    // currentVideo () {
	    //   return this.videos ? _.find(this.videos, {id: this.$route.params.id * 1}) : {};
	    // },
	    videoId: function videoId() {
	      return this.currentVideo ? this.currentVideo.ytID : '';
	    },
	    videoURL: function videoURL() {
	      var base = 'https://www.youtube.com/embed/';
	      var end = '?enablejsapi=1&playsinline=1&controls=0&showinfo=0&modestbranding=1&fs=0';
	      var vid = this.videoId;
	      return base + vid + end;
	    },
	    showNav: function showNav() {
	      return this.$store.state.ui.showNav;
	    },
	    hasPreloaded: function hasPreloaded() {
	      return this.$store.state.ui.hasPreloaded;
	    },
	    isTouchDevice: function isTouchDevice() {
	      return this.$store.state.ui.isTouchDevice;
	    },
	    progressBar: function progressBar() {
	      return this.timeToOffset(this.currentTime);
	    },
	    modals: function modals() {
	      var $vm = this;
	      // return _.filter($vm.details, {section: {video: $vm.$route.params.id * 1}})
	      return _lodash2.default.chain($vm.details).filter({ section: { video: $vm.$route.params.id * 1 } }).orderBy('section.time').value();
	    },
	    modalTimes: function modalTimes() {
	      return this.modals ? _lodash2.default.map(this.modals, function (modal) {
	        return modal.section.time;
	      }) : [];
	    }
	  }
	});

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.notTouchDevice = exports.hideNav = exports.showNav = exports.toggleClass = exports.logoAnimated = exports.preloadedHalf = exports.preloaded = exports.preloading = exports.routeChange = exports.getContent = undefined;
	
	var _types = __webpack_require__(5);
	
	var types = _interopRequireWildcard(_types);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var getContent = exports.getContent = function getContent(state) {
	  _jquery2.default.getJSON(window.location.pathname + 'data/content.json', function (data) {
	    window.data = window._.assign({}, data);
	    data.details.forEach(function (item, index) {
	      item.gid = index + 1;
	    });
	    state.commit(types.GET_CONTENT, data);
	  });
	};
	
	var routeChange = exports.routeChange = function routeChange(state, prevRoute) {
	  state.commit(types.ROUTE_CHANGE, prevRoute);
	};
	
	var preloading = exports.preloading = function preloading(state) {
	  state.commit(types.IS_PRELOADING);
	};
	
	var preloaded = exports.preloaded = function preloaded(state) {
	  state.commit(types.HAS_PRELOADED);
	};
	
	var preloadedHalf = exports.preloadedHalf = function preloadedHalf(state) {
	  state.commit(types.HAS_PRELOADED_HALF);
	};
	
	var logoAnimated = exports.logoAnimated = function logoAnimated(state) {
	  state.commit(types.LOGO_ANIMATED);
	};
	
	var toggleClass = exports.toggleClass = function toggleClass(state, className) {
	  state.commit(types.TOGGLE_CLASS, className);
	};
	
	var showNav = exports.showNav = function showNav(state) {
	  state.commit(types.SHOW_NAV);
	};
	
	var hideNav = exports.hideNav = function hideNav(state) {
	  state.commit(types.HIDE_NAV);
	};
	
	var notTouchDevice = exports.notTouchDevice = function notTouchDevice(state) {
	  state.commit(types.NOT_TOUCH_DEVICE);
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(11);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _mutations = __webpack_require__(24);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  state: {
	    ui: {
	      isTouchDevice: true
	    },
	    routes: {},
	    content: {}
	  },
	  actions: actions,
	  mutations: _mutations2.default
	});

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types$GET_CONTENT$ty;
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _types = __webpack_require__(5);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_types$GET_CONTENT$ty = {}, _defineProperty(_types$GET_CONTENT$ty, types.GET_CONTENT, function (state, content) {
	  // state.content = content;
	  _vue2.default.set(state, 'content', content);
	}), _defineProperty(_types$GET_CONTENT$ty, types.ROUTE_CHANGE, function (state, prevRoute) {
	  _vue2.default.set(state.routes, 'prevRoute', prevRoute);
	}), _defineProperty(_types$GET_CONTENT$ty, types.IS_PRELOADING, function (state) {
	  _vue2.default.set(state.ui, 'isPreloading', true);
	}), _defineProperty(_types$GET_CONTENT$ty, types.HAS_PRELOADED, function (state) {
	  _vue2.default.set(state.ui, 'isPreloading', false);
	  _vue2.default.set(state.ui, 'hasPreloaded', true);
	}), _defineProperty(_types$GET_CONTENT$ty, types.HAS_PRELOADED_HALF, function (state) {
	  _vue2.default.set(state.ui, 'hasPreloadedHalf', true);
	}), _defineProperty(_types$GET_CONTENT$ty, types.LOGO_ANIMATED, function (state) {
	  _vue2.default.set(state.ui, 'logoAnimated', true);
	}), _defineProperty(_types$GET_CONTENT$ty, types.TOGGLE_CLASS, function (state, className) {
	  _vue2.default.set(state.ui, className, !state.ui[className]);
	}), _defineProperty(_types$GET_CONTENT$ty, types.SHOW_NAV, function (state) {
	  _vue2.default.set(state.ui, 'showNav', true);
	}), _defineProperty(_types$GET_CONTENT$ty, types.HIDE_NAV, function (state) {
	  _vue2.default.set(state.ui, 'showNav', false);
	}), _defineProperty(_types$GET_CONTENT$ty, types.NOT_TOUCH_DEVICE, function (state) {
	  _vue2.default.set(state.ui, 'isTouchDevice', false);
	}), _types$GET_CONTENT$ty);

/***/ },
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ function(module, exports) {

	module.exports = "<div class=about> <div class=about__inner> <h1 class=about__title>About Okinawa</h1> <div class=about__map> <a href=\"https://www.google.com/flights/#search;t=OKA;\" target=_blank> <img :src=\"'images/world-map.png'\" alt=\"\"/> </a> </div> <div class=about__section v-for=\"(item, index) in content\"> <img :src=\"'images/separator.svg'\" alt=\"\"/> <h3 class=about__subtitle>{{item.title}}</h3> <p v-html=item.copy></p> <a v-if=\"index == 0\" class=about__cta href=\"https://www.google.com/flights/#search;t=OKA;\" target=_blank> <img class=base :src=\"'images/cta_findflights.svg'\" alt=\"Getting there\"/> <img class=hover :src=\"'images/cta_findflights-hover.svg'\" alt=\"Getting there\"/> </a> </div> <slot></slot> </div> </div> ";

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = "<div class=audio-player> <audio> <source :src=\"'audio/music.mp3'\" type=audio/mpeg> </audio> <button v-on:click=togglePlay class=\"ytp-play-button ytp-button\" aria-live=assertive tabindex=32 aria-label=Pause> <svg width=100% height=100% viewBox=\"0 0 36 36\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <g> <path class=st0 d=\"M12.9,0l-0.1,0c-0.2,0-0.5,0.1-0.9,0.3c0,0-6.3,5.5-6.5,5.7H2C1.2,6,0.5,6.7,0.5,7.5v9.2\r\n           c0,0.8,0.7,1.5,1.5,1.5h3.4c0.3,0.3,6.5,5.5,6.5,5.5c0.3,0.2,0.6,0.3,0.9,0.3l0.1,0c0.6-0.1,1-0.5,1.1-1V1\r\n           C13.9,0.5,13.5,0.1,12.9,0z M12.5,22.2c-2.3-2-5.7-4.8-6-5.1c-0.3-0.3-0.7-0.4-1.1-0.4H2v-0.2v-9h3.4c0.4,0,0.8-0.2,1-0.4\r\n           c0.3-0.3,3.7-3.2,6-5.3L12.5,22.2L12.5,22.2z\"/> <path class=st0 d=\"M16.3,14.6c-0.4,0.2-0.5,0.6-0.3,1c0.1,0.3,0.4,0.4,0.7,0.4c0.1,0,0.2,0,0.3-0.1c1.5-0.8,2.5-2.3,2.5-4\r\n           S18.5,8.8,17,8c-0.4-0.2-0.8,0-1,0.3c-0.2,0.4,0,0.8,0.3,1c1,0.5,1.6,1.5,1.6,2.6S17.3,14.1,16.3,14.6z\"/> <path class=st0 d=\"M16.2,2.8c-0.4-0.1-0.8,0.2-0.9,0.6c-0.1,0.4,0.2,0.8,0.6,0.9c3.7,0.7,6.4,4,6.4,7.7s-2.7,7-6.4,7.7\r\n           c-0.4,0.1-0.7,0.5-0.6,0.9c0.1,0.4,0.4,0.6,0.7,0.6l0.1,0c4.4-0.9,7.6-4.7,7.6-9.2C23.8,7.5,20.6,3.7,16.2,2.8z\"/> </g> <g v-show=!playing> <path class=st0 d=M0.8,23.3C4.7,19.2,23.2,0.9,23.2,0.9 /> <path class=st0 d=\"M0.8,24c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-1c3.8-4,22.2-22.2,22.4-22.4c0.3-0.3,0.7-0.3,1,0\r\n     \t\t\tc0.3,0.3,0.3,0.7,0,1C23.5,1.6,5.1,19.7,1.3,23.7C1.2,23.9,1,24,0.8,24z\"/> </g> </svg> </button> </div> ";

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = "<div class=\"\"> <pre-loader></pre-loader> <div class=heroes> <div class=\"slider js_slider\"> <div class=\"frame js_frame\"> <ul class=\"heroes__images slides js_slides\"> <li class=\"js_slide heroes__images-1\"></li> <li class=\"js_slide heroes__images-2\"></li> <li class=\"js_slide heroes__images-3\"></li> </ul> </div> </div> <div class=heroes__inner> <h2 v-bind:class=\"{isSliding: sliding}\" v-show=\"logoAnimated && !textAnimated\"><span v-html=activeHeading></span></h2> <h2 v-bind:class=\"{isSliding: sliding}\" v-show=\"logoAnimated && textAnimated\"><span>{{activeHeading}}</span></h2> <div class=heroes__intro v-show=!logoAnimated> <img class=heroes__intro-image :src=\"'images/hero-sequence/logo0001.png'\" alt=\"\"/> </div> <div class=heroes__cta> <a :href=\"'#/videos/' + (activeIndex + 1)\"> <img class=base :src=\"'images/cta_watch.svg'\" alt=\"Show me\"/> <img class=hover :src=\"'images/cta_watch-hover.svg'\" alt=\"Show me\"/> </a> </div> <ul class=heroes__nav> <li v-for=\"image in content.images\" v-on:click=showSlide(image.id) v-bind:class=\"{isActive: image.id == activeImage}\"> <span v-html=image.title></span> </li> </ul> </div> </div> <slot></slot> </div> ";

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = "<div class=map :class=\"{isReady: ready}\"> <div class=map__full> <div class=map__layer> <div class=map__wave></div> <svg version=1.1 id=map xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 872 580\" xml:space=preserve> <g id=okinawa transform=\"translate(481.000000, 0.000000)\"> <path id=Fill-1 class=st0 d=\"M175.4,390.7c-0.7-1.2-2.7-0.2-3.8-1l0.3,0c-1.1-0.4-2.3-0.5-3.4-0.2c0.9,1.9,1,4.1,0.5,6.2\r\n        \t\tc-0.2,0.9-0.6,1.7-0.7,2.6c-0.1,0.9,0.1,1.9,0.8,2.5c0.5,0.4,1.3,0.5,1.7,1c0.2,0.2,0.3,0.4,0.5,0.5c0.6,0.3,1.1-0.4,1.2-1\r\n        \t\tc0.1-0.6,0-1.3,0.4-1.8c0.4-0.5,1.1-0.6,1.6-0.9c1-0.7,1.1-2.1,1.1-3.2c0-1.1,0-2.3,0-3.4C175.6,391.4,175.6,391,175.4,390.7\r\n        \t\t M186.6,350.1l0.5,0.8c-2.3-1.1-4.5-2.2-6.8-3.3c-0.5-0.2-1-0.5-1.5-0.4c-1,0.1-1.6,1.2-1.6,2.2c0,1,0.4,1.9,0.6,2.9\r\n        \t\tc0.4,1.5,0.3,3.2,1.1,4.6c0.7,1.4,2.7,2.4,3.9,1.3c0.9-0.8,0.8-2.3,1.5-3.3c0.6-0.9,1.6-1.3,2.4-2.1\r\n        \t\tC187.4,352,187.6,350.5,186.6,350.1 M203.1,321.6c-1.6-1.8-3.5-3.3-5.7-4.4c0.8-0.7,1.9-1.1,2.9-1.3c-0.3-1.4-1.1-2.6-2.3-3.4\r\n        \t\tc-1.7-0.4-2.2,3.1-3.9,2.9c-0.4,0-0.8-0.3-1.2-0.4c-0.8-0.2-1.6,0.2-2.2,0.8c-1.8,1.8-1.9,4.6-2.9,6.9c-1.6,3.8-6,6.2-10.1,5.5\r\n        \t\tc-1.2-0.2-2.6-0.6-3.6,0c-1.8,1-1.4,3.7-0.6,5.6c0.8,1.9,1.5,4.5-0.2,5.8c1.2,0.9,3-0.6,4.4,0c0.8,0.4,1.1,1.4,1.8,2\r\n        \t\tc1.3,1.2,3.5,0.5,5-0.5c3.1-2,5.6-4.7,7.4-7.9c-1.8-0.3-3.3-1.9-3.5-3.7c1.6,0.7,3.4,1.4,5,0.8c1.1-0.4,2-1.4,2.9-2.2\r\n        \t\tc1.8-1.4,4.2-2,6.4-1.7c0.6-0.8-0.2-2.1-1.2-2.1C201.3,323.3,202,322,203.1,321.6 M206.4,302.5l0.7-0.3l-4.3,0\r\n        \t\tc-0.5,0-1.1,0-1.6,0.4c-1.1,0.9-0.1,3.3-1.5,3.8c-0.6,0.3-1.6,0.1-1.7,0.7c-0.1,0.3,0.1,0.6,0.3,0.8c1.1,1.4,2.1,2.8,3.2,4.2\r\n        \t\tc0.5,0.7,1.2,1.5,2,1.5c0.8,0.1,1.6-0.5,2-1.2c0.4-0.7,0.5-1.6,0.7-2.4c0.3-2.2,0.6-4.3,0.9-6.5C207.2,303,206.9,302.2,206.4,302.5\r\n        \t\t M212.7,113c1.1,0.6,2.4,1,3.3,1.9c0.2,0.3,0.4,0.6,0.7,0.7c0.8,0.5,1.7-0.4,2.2-1.2c1.8-2.7,3.6-5.9,2.7-9\r\n        \t\tc-0.3-0.9-0.8-1.7-1.6-2.1c-0.8-0.3-1.6-0.3-2.4-0.4c-0.8-0.1-1.5-0.4-2.2-0.6c-2.6-0.4-5.2,1.6-5.7,4.1\r\n        \t\tC209,109,210.4,111.7,212.7,113 M125.7,155.3c0.3,0.1,0.7,0.1,1-0.1c1.9-0.9,1.9-3.6,3.2-5.1c0.7-0.8,1.7-1.2,2.3-2.1\r\n        \t\tc1.4-1.8,0.3-4.7-1.7-5.9s-4.5-1-6.8-0.5c-0.6,0.1-1.3,0.3-1.6,0.7c-0.3,0.4-0.4,0.8-0.4,1.3c-0.4,3.7,1.9,7.1,3.3,10.6\r\n        \t\tC125.1,154.7,125.3,155.2,125.7,155.3 M68,106.6c2.6,0.6,5-1.7,7.6-2.1c4-0.7,8.4,2.9,12,0.8c0.4-0.3,0.9-0.6,1.4-0.6\r\n        \t\tc0.9,0,1.3,1.2,1.5,2c0.2,0.9,1,1.9,1.8,1.5c0.4-0.2,0.6-0.6,0.9-0.8c1.5-1.2,3.3,1.8,5.1,1.4c1-0.2,1.5-1.3,2.4-1.8\r\n        \t\tc1.2-0.7,2.7,0,4.1-0.2c2.4-0.4,3.3-3.2,3.8-5.6c0.2-0.9,0.4-1.9,0.1-2.8c-0.2-0.6-0.6-1.1-1-1.6c-2-2.5-4.6-4.4-7.5-5.7\r\n        \t\tc0.9-2.1-1.4-4.1-3.3-5.3c-0.3-0.2-0.6-0.4-1-0.4c-1-0.1-1.6,1-2.2,1.7c-2.2,2.2-6.1,1.2-8.8,2.7c-0.4,0.2-0.8,0.5-1.3,0.6\r\n        \t\tc-0.5,0.1-1,0-1.4-0.2c-2.3-0.6-4.7-1.2-7-1.8c-0.5-1.4-2-2.3-3.5-2.5c-1.5-0.2-3,0.1-4.4,0.4c-1.4,0.3-3.1,0.8-3.6,2.2\r\n        \t\tc-0.6,1.9,1.6,3.9,0.8,5.8c-0.3,0.6-0.8,1-1.2,1.6c-1,1.5-0.4,3.5,0.2,5.2C64.3,103.4,65.5,106,68,106.6 M389.9,76.3\r\n        \t\tc-0.4,0.3-0.8,0.5-1.2,0.8c-1.3-0.2-1.7-1.9-1.2-3.1c0.4-1.2,1.3-2.3,1.4-3.6c0.1-1.2-0.6-2.5-0.4-3.7c0.1-0.8,0.6-1.4,0.9-2.1\r\n        \t\tc1.6-3.6-0.2-7.8-2.8-10.8c-0.6-0.7-1.2-1.4-1.5-2.3c-0.2-0.7-0.1-1.5,0-2.2c0.2-1.9,0.5-3.7,0.7-5.6c0.4-2.8,0.7-5.6,0.1-8.3\r\n        \t\tc-1.9-2.2-5.5-2.6-6.9-5.1c-0.8-1.4-0.7-3.2-0.5-4.8c0.2-1.6,0.4-3.3-0.2-4.8c-0.6-1.5-2.5-2.6-3.9-1.8c-1.1,0.6-1.8,2.1-3,1.8\r\n        \t\tc-0.3-0.1-0.6-0.3-0.9-0.6c-2-1.8-3.6-3.9-4.9-6.3c-0.3-0.6-0.6-1.3-1.2-1.6c-0.5-0.3-1.2-0.4-1.8-0.5c-3.3-0.6-6-4-8.2-6.6\r\n        \t\tc-0.4-0.4-0.3-1.1,0-1.7c0.3-0.5,0.7-0.9,1.1-1.3c0.2-0.2,0.4-0.5,0.3-0.8c0-0.1-0.1-0.3-0.3-0.4c-1.3-1.2-3.4-1.3-5.1-0.5\r\n        \t\tc-1.7,0.7-2.9,2-4.2,3.4c-1,1.1-2,2.3-2.4,3.7c-0.5,1.6-0.2,3.5,0.8,5c0.8,1.2,2.1,2,2.9,3.2c0.8,1.4,0.8,3,0.8,4.6\r\n        \t\tc0,1.7,0,3.4-0.6,4.9c-0.5,1.3-1.5,2.4-2.4,3.5c-2.6,3.1-4.9,6.5-6.9,10c-1.3,2.2-2.4,4.5-2.7,6.9c-0.1,0.8-0.1,1.7-0.1,2.5\r\n        \t\tc-1.6,1.3-3.1,2.9-4.5,4.4c-1.4,1.4-2.7,2.9-4.1,4.3c-1.6,1.7-3.2,3.4-4.8,5.2c-3.4,3.9-6.5,7.9-10,11.7c-1,1.1-2.1,2.1-2.9,3.4\r\n        \t\tc-0.9,1.4-1.5,3.1-2.9,4.1c-0.6,0.4-1.4,0.7-2.1,1c-1.3,0.5-2.6,0.9-3.9,1.4c-1.8,0.6-3.9,1.2-5.6,0.3c-0.6-0.3-1.1-0.8-1.8-1\r\n        \t\tc-0.6-0.2-1.5,0-1.7,0.7c-0.2,0.8,0.8,1.3,1.6,1.7c1.8,0.9,3.1,2.8,3.3,4.8c-1.3,2.2-0.8,5.3-2,7.6c-1.4,2.6-4.6,3.6-6.9,5.5\r\n        \t\tc-1.2,1-2.1,2.3-3.3,3.2c-1.8,1.3-4,1.8-6.2,2.1c-2.6,0.4-5.4,0.8-7.1,2.7c-0.8,0.9-1.3,2-1.8,3c-0.8,1.6-1.8,3-3,4.3\r\n        \t\tc-1.1,1.2-2.3,2.3-3.1,3.6c-0.9,1.4-1.3,3.1-0.8,4.6c0.3,0.7,0.7,1.3,1,1.9c0.5,1.4,0.2,3-0.1,4.4c-0.2,0.8-0.4,1.7-1,2.3\r\n        \t\tc-0.9,0.8-2.2,0.8-3.4,0.8c-2.8,4.4-6.2,9-11.3,10.2c-1.4,0.3-2.8,0.4-4.1,0.8c-1.8,0.6-3.4,1.7-5.2,2.5c-4.1,1.8-8.9,1.3-13,3\r\n        \t\tc-2.2,0.9-4.2,2.5-6.5,2.7c-2.5,0.2-4.8-1.3-7.3-1.1c-0.9,0.1-1.9,0.3-2.6-0.1c-0.8-0.5-0.9-1.5-1.3-2.3c-1.1-2.8-4.3-4-6.6-5.9\r\n        \t\tc-0.5-0.4-1.1-1-1.3-1.6c-0.7-2.2,2.3-4.6,1.2-6.7c1.8,0.9,3.6,1.9,5.4,2.8c0.5,0.2,0.9,0.5,1.3,0.9c0.8,0.9,1.4,2.4,2.6,2.3\r\n        \t\tc1.9-0.3,1.1-4.3,3-4.2c0.7,0,1.2,0.7,1.7,1.3c2,2,5.9,1.3,7.5,3.6c0.5,0.6,0.8,1.5,1.6,1.7c1,0.1,1.6-1.1,1.6-2.1\r\n        \t\tc0.1-4.9-4.9-8.3-7.1-12.8c-0.8-1.6-1.2-3.4-1.9-5.1c-0.1-0.3-0.3-0.6-0.5-0.8c-0.3-0.2-0.7-0.3-1-0.3c-4.5-0.2-8.4,2.9-11.3,6.3\r\n        \t\tc-1.4-2.2-0.7-5.4,1.5-6.8c1.2-0.7,2.8-1.1,3.1-2.4c0.4-1.4-1-2.6-2.3-3.4c-2-1.3-4.2-2.5-6.6-2.5c-0.9,0-1.9,0.3-2.8,0\r\n        \t\tc-0.9-0.2-1.7-0.9-2.5-1.5c-0.8-0.6-1.7-1.1-2.7-0.8c-0.9,0.2-1.5,1.6-0.8,2.2c-1.8-2.1-3.6-4.3-5.4-6.4c-0.5-0.6-1.1-1.3-1.9-1.6\r\n        \t\tc-0.6-0.2-1.3-0.2-1.9-0.1c-4.9,0.3-9.8,1.3-14.5,2.8c-3.6,1.2-8-0.7-11.6,0.5c-1.6,0.5-3.3,1.5-4.7,0.6c-0.6-0.3-0.9-0.9-1.5-1.2\r\n        \t\tc-0.9-0.4-2,0-3-0.1c-1.8-0.2-2.9-1.9-4-3.3c-1.1-1.4-2.9-2.7-4.5-1.9c-1,0.5-1.4,1.7-1.5,2.8s0.1,2.3-0.1,3.4\r\n        \t\tc-0.3,1.9-1.7,3.5-2.8,5.1c-1.1,1.6-1.9,3.8-1,5.5c0.9,1.8,3.1,2.4,4.8,3.5c0.4,0.3,0.8,0.6,1,1c0.3,0.8,0,1.7,0.1,2.5\r\n        \t\tc0.1,0.9,0.7,1.6,1,2.4c0.9,2.1,0,4.5-1.2,6.4c-1.1,1.9-2.6,3.9-2.8,6.1c-0.2,2,0.6,4,1.4,5.8c2.2,5.4,4.5,10.8,6.7,16.2\r\n        \t\tc0.4,1,0.9,2.1,1.5,3c2.4,3.6,7.2,4.8,11.5,5.2c1.1,0.1,2.6,0,3-1.1c0.2-0.5,0.1-1.2,0.2-1.7c0.2-1,1-1.7,2-1.9\r\n        \t\tc0.9-0.2,1.9,0,2.8,0.4c1.6,0.7,3,2,3.9,3.5c3.1-0.1,6.7,0.3,9.1,2.3c1,0.8,1.8,2,2.8,2.8c2.3,2,5.6,2.3,8.6,3.1\r\n        \t\tc3,0.7,6.2,2.5,6.7,5.5c0.2,1.4-0.2,2.9-0.7,4.3c-2.2,6.1-5.2,12-8.8,17.4c-0.2,0.3-0.5,0.7-0.9,0.9c-0.8,0.3-1.6-0.4-2.5-0.8\r\n        \t\tc-1.4-0.5-3,0.3-4.1,1.4c-1.1,1.1-1.9,2.4-3.2,3.2c-2.3,1.3-5.3,0.5-7.6,1.8c-1.1,0.6-1.9,1.6-2.8,2.6c-2,2.4-4,4.9-6,7.3\r\n        \t\tc-0.5,0.6-1,1.2-1.7,1.4c-0.6,0.1-1.2,0-1.8-0.1c-3.5-0.5-6.9,1.4-9.9,3.2c-0.7,0.4-1.5,0.9-1.9,1.7c-0.4,0.8-0.2,1.8-0.6,2.6\r\n        \t\tc-0.9,2-3.9,1.7-5.8,0.4c-1.8-1.2-3.6-3.1-5.8-3c-2.9,0.1-4.5,3.4-6.5,5.5c-0.3,0.3-0.7,0.6-1.1,0.7c-1.1,0.1-1.5-1.5-2.4-2.2\r\n        \t\tc-0.9-0.8-2.4-0.6-3.4,0.2c-0.9,0.8-1.5,1.9-2,3c-0.6,1.3-1.2,2.8-1.1,4.2c0.3,2.5,2.9,4.8,1.8,7.1c-0.3,0.8-1,1.3-1.7,1.8\r\n        \t\tc-4.2,3.3-8.5,6.6-13.2,9.1c-1.3,0.7-2.6,1.3-3.8,2.2c-2.6,1.9-4.3,4.9-4.7,8c-0.2,2,0,4.2-1.1,6s-4.3,2-4.8,0\r\n        \t\tc-1.2,0.6-2.2,1.2-3.4,1.8c-0.2,0.1-0.5,0.3-0.8,0.3c-0.4,0-0.9-0.2-1.3-0.4c-1.4-0.8-2.8-1.7-4.2-2.5c-0.5-0.3-0.9-0.6-1.2-1\r\n        \t\tc-0.3-0.3-0.4-0.8-0.7-1.1c-0.6-0.5-1.7-0.2-2.2,0.4c-0.6,0.6-0.8,1.4-1.2,2.2c-1.9,3.5-6.5,4.4-9.7,6.7c-2.2,1.5-4,3.8-6.7,4\r\n        \t\tc-0.6,0-1.1,0-1.6-0.4c-0.4-0.3-0.6-0.7-0.8-1.1c-0.6-1.3-1.2-2.7-1.8-4c-0.8-1.8-1.7-3.7-3.4-4.7c-2-1.2-4.6-0.8-7-0.3\r\n        \t\tc1.9,1.6,1.6,4.5,1.3,7c-0.6,5.5-0.1,11.2,1.4,16.6c0.6,2.1,1.4,4.2,2.1,6.3c0.4,1.1,0.8,2.3,1.5,3.3c0.5,0.9,1.2,1.7,1.8,2.5\r\n        \t\tc3.3,4.2,6,8.8,8,13.7c0.2,0.5,0.4,1.1,0.1,1.6c-0.2,0.3-0.6,0.4-0.9,0.7c-0.6,0.5-0.6,1.5-0.2,2.3c0.4,0.7,1,1.3,1.6,1.9\r\n        \t\tc1.8,2.1,2.5,5.1,1.8,7.8c-0.4,1.4-1.2,2.7-1.3,4.2c-0.2,2.2,0.9,4.3,2.1,6.1c0.5,0.8,1,1.7,1.9,2.2c0.9,0.5,2.1,0.3,2.5-0.6\r\n        \t\tc0.5,0.3,0.8,1,0.6,1.6c1.1,3.4,1.6,6.1,2,9.7c0.1,0.8,0.2,1.6-0.2,2.3c-0.5,1.1-1.8,1.6-2.8,2.3c-1.8,1.4-2.4,3.7-4,5.3\r\n        \t\tc-2.7,2.6-7.5,2.3-9.7,5.3c-0.6,0.9-1,1.9-1.7,2.7c-0.7,0.8-1.8,1.4-2.8,0.9c-0.5-0.3-0.8-0.8-1.4-1c-0.8-0.3-1.7,0.1-2.4,0.5\r\n        \t\tc-3,1.8-5.8,4.1-8.2,6.6c-2,2.2-4.4,4.8-7.3,4.5c-0.7-0.1-1.4-0.3-2.1,0c-2,1,0.7,4.5-0.7,6.3c-1.1,1.5-3.7,0.2-5.2,1.4\r\n        \t\tc-0.6,0.5-0.9,1.3-1.1,2.1c-0.6,2.2-1.3,4.3-1.9,6.5c0.8,0.3,1.7,0.3,2.4-0.2c1.5,2.2-0.9,5-3.2,6.1c-2.4,1.1-5.3,1.9-6.2,4.4\r\n        \t\tc-0.6-1.5-2.8-1.7-4.1-0.9c-1.3,0.9-2.1,2.4-2.7,3.9c-0.7,1.6-1.4,3.2-2.1,4.8c-0.3,0.6-0.5,1.3-0.5,1.9c0.1,0.9,0.7,1.6,1.2,2.4\r\n        \t\tc1.1,1.6,1.7,3.6,1.5,5.6c-0.1,1-0.2,2.2,0.5,2.9c0.5,0.5,1.1,0.6,1.7,0.8c1.4,0.5,2.6,1.6,3.2,3c-1.7-0.7-3.7-0.7-5.4,0.1\r\n        \t\tc4.8,1.9,3.8,9.8,8,12.7c-0.2,1.5-0.4,3.1-0.7,4.6c-0.1,0.5-0.2,1-0.5,1.3c-0.5,0.4-1.2,0.2-1.9,0.3c-1.4,0.1-2.4,1.5-2.5,2.9\r\n        \t\tc-0.1,1.4,0.4,2.8,0.9,4.1c0.5,1.3,1,2.5,1.5,3.8c0.2,0.6,0.7,1.4,1.3,1.4c1.4-1.2-0.9-4.4,0.8-5.1c0.9-0.4,1.8,0.6,2.3,1.5\r\n        \t\tc1.2,2.1,2.4,4.3,2.2,6.7c-0.1,0.7-0.2,1.3-0.2,2c0.1,1.1,0.9,2.1,1.3,3.1c0.4,1.1,0.1,2.6-1,2.8c-2.9,0.5-3.3,4.7-3.3,7.6\r\n        \t\tc0,3.1,0.1,6.1,0.1,9.2c0,0.5,0,1.1,0.3,1.6c1,1.3,3.1-0.1,4.7-0.1c2.7,0,4.4,3.9,7,3.3c0.8-0.2,1.4-0.7,2-1.3\r\n        \t\tc1.7-1.6,3.4-3.1,5-4.7c0.8-0.7,1.5-1.4,2-2.3c0.8-1.5,1.2-3.9,3-4c1.2-0.1,2.1,1,3,1.8c3,2.4,7.4,1.4,11,0.3\r\n        \t\tc0.6-0.2,1.3-0.5,1.5-1.1c0.2-0.6-0.1-1.2,0-1.7c0.2-1.2,1.7-1.5,2.8-2c4.7-2.2,4-10.1,8.6-12.3c1.4-0.7,3-0.7,4.5-1.3\r\n        \t\tc3-1.2,5.1-4.9,8.3-4.4c-0.6-0.5-0.6-1.5-0.2-2.2c1-1.8,3.4-2.2,5.4-1.9s4.1,1,6.1,0.6c4.7-1,5.8-7.3,9.6-10.2\r\n        \t\tc1.1-0.8,2.4-1.5,2.8-2.8c0.2-0.6,0.1-1.2,0.3-1.7c0.2-0.5,0.7-0.9,1.2-1.3c1.9-1.4,3.9-2.7,6.1-3.8c0.5-0.3,1.1-0.6,1.5-1\r\n        \t\tc0.3-0.3,0.7-0.6,0.7-1.1c0-2.8-0.4-9.2-2.3-12.3c-2.1-3.5-7.2-2.7-11.2-1.8c-4,0.9-7.4,3.6-9.6,7c-0.8,1.3-2,2.8-3.4,2.4\r\n        \t\tc0.2-3-1-6-3.2-8.1c-0.6-0.5-1.2-1-1.7-1.7c-0.4-0.5-0.7-1.1-0.9-1.6c-1.7-3.8-2.3-8.5,0.1-11.9c-0.3-0.4-0.6-0.8-0.9-1.3\r\n        \t\tc1.2-1.5,3.1-2.3,4.8-3c0.6-0.2,1.2-0.5,1.6-1c0.5-0.6,0.4-1.5,0.8-2.2c0.7-1.5,3-1.9,3.5-3.5c0.4-1.2-0.3-2.4-0.5-3.6\r\n        \t\tc-0.2-1.2,0-2.3,0.2-3.5c0.6-3.9,1.3-7.8,3-11.4c2.1-4.5,5.8-8.2,10.2-10.4c0.8-0.4,1.6-0.7,2.1-1.4c0.4-0.6,0.5-1.4,0.5-2.2\r\n        \t\tc0.1-2.2,0-4.9-1.7-6.3c-2.3-1.9-2-6.7,0.4-8.5c0.6-0.5,1.4-0.8,2.2-0.7c1.5,0.1,2.8,1.6,4.2,1.1c1.1-0.4,1.5-1.7,1.6-2.9\r\n        \t\tc0.1-1.2,0.2-2.5,1-3.3c1-0.9,2.6-0.7,3.9-0.7c1.3,0,2.6-0.2,3.8-0.6c0.4-0.1,0.8-0.3,1.1-0.7c0.2-0.3,0.3-0.7,0.2-1\r\n        \t\tc-0.4-3-5.7-2.8-6.4-5.7c-0.4-1.8,2-3.3,3.5-2.3c0.6,0.4,0.9,1,1.5,1.3c1.3,0.8,3-0.1,4.4,0.5c0.3,0.2,0.7,0.4,1,0.5\r\n        \t\tc1,0.3,2.1-0.7,1.9-1.7c-0.2-0.6-0.7-1.3-0.2-1.8c0.1-0.1,0.4-0.2,0.6-0.2c1-0.1,1.8,0.9,2.5,1.7c0.7,0.8,1.7,1.6,2.7,1.1\r\n        \t\tc-0.2-1,0.5-2.1,1.5-2.4c-0.7-2-1.4-3.9-2.2-5.9c0.5,0.5,0.9,1,1.4,1.5c4.5,4.7,8.4,10,11.8,15.6c0.5,0.8,0.9,1.6,1.6,2.2\r\n        \t\tc0.7,0.7,1.5,1.2,2.4,1.7c2.1,1.3,4.2,2.5,6.5,3.3c1.1,0.4,2.2,0.7,3.1,1.4c0.9,0.7,1.4,1.8,2.2,2.7c0.8,0.8,2.3,1.3,3.1,0.4\r\n        \t\tc0.5-0.5,0.5-1.3,0.5-2c0-9.3-4.7-18.8-12.8-23.4c-0.8-0.4-1.6-0.8-2.1-1.5c-0.6-0.6-0.9-1.4-1.4-2.1c-1.2-1.3-3.1-1.6-4.6-2.6\r\n        \t\tc-1.7-1.1-2.7-2.9-3.6-4.7c-1.3-2.3-2.5-4.8-2.6-7.5c-0.1-2.4,0.9-4.8,2.3-6.8c0.4-0.6,0.8-1.1,0.8-1.8c0-0.7-0.5-1.4-1.2-1.3\r\n        \t\tc-2-3.9-6.2-7.3-9.6-9.9c-3.8-2.9-7.6-5.8-11.4-8.7c-0.5-0.4-1-0.8-1.3-1.3c-0.8-1.9,1.4-4.7-0.3-5.7c-1.7,0.7-3.8,0.1-4.9-1.3\r\n        \t\tc-1.1-1.5-1-3.7,0.2-5.1c0.5-0.6,1.4-1.1,2.1-0.7c0.4,0.2,0.6,0.5,0.9,0.8c1.3,1.2,3.5,0.4,4.5-1c1-1.4,1.3-3.2,1.8-4.8\r\n        \t\tc1.8-5.8,7.1-10.4,13.1-11.3c1-0.2,2.1-0.2,3.1,0.1c1,0.3,1.9,1.1,3,1.2c1.2,0.1,2.2-0.6,3.4-0.8c3.3-0.6,5.7,3.1,8.9,4.4\r\n        \t\tc2.8,1.1,6.3,0.4,8.6,2.4c0.7,0.6,1.2,1.4,1.9,2c4,3.6,11.1-1.5,15.6,1.5c-1.2-2.6-2.3-5.8-0.8-8.3c0.5-0.8,1.2-1.4,1.6-2.2\r\n        \t\tc1.6-2.9-0.4-7.6,2.5-9.2c2.7-1.6,5.6,1.9,8.7,2.1c1.2,0.1,2.3-0.4,3.4-0.8c5.6-2.1,11.4-4.4,15.4-8.9c1.5-1.7,2.8-4.4,1.4-6.2\r\n        \t\tc-0.7-0.9-1.8-1.3-2.7-2c-1.3-1.1-1.8-2.8-2.2-4.5c-0.4-1.5-0.6-3.6,0.8-4.3c1.7-0.9,3.4,1.2,4.2,3c1.3-1.7,1.5-4.3,0.4-6.2\r\n        \t\tc1.2-2,4.4-1.2,6.3,0.2c1.9,1.4,4.1,3.3,6.3,2.5c2.7-0.9,3.2-4.9,5.9-5.9c1.5-0.5,3.2,0.1,4.7,0.3c1.6,0.1,3.6-0.7,3.5-2.3\r\n        \t\tc-0.1-1.3-1.6-2-2.8-2.3c-0.2-3.2-1.4-6.4-3.1-9.1c-1.2-1.8-2.7-3.7-2.2-5.8c0.1-0.2,0.1-0.5,0.3-0.6c0.4-0.3,1-0.1,1.3,0.3\r\n        \t\tc0.3,0.4,0.5,0.9,0.8,1.2c0.7,0.9,1.9,1.1,3,1.1c4.4-0.1,8.6-3.3,12.9-2.2c1.9,0.5,3.4,1.7,4.9,2.9c1.6,1.3,3.1,2.5,4.5,3.9\r\n        \t\tc0.5,0.6,1.1,1.1,1.8,1.4c1.2,0.5,2.5-0.1,3.5-0.8c1.1-0.7,2-1.6,3.2-1.9c1.3-0.4,2.9-0.2,3.6-1.4c0.3-0.6,0.3-1.3,0.5-1.9\r\n        \t\tc0.4-1.2,1.7-1.9,3-2.2c1.3-0.3,2.6-0.3,3.8-0.6c1.5-0.5,2.8-1.6,4.3-2.1c2.2-0.8,4.5-0.5,6.8-0.2c-0.3-2.7-0.4-5.4-0.6-8.1\r\n        \t\tc1.8-0.2,3.5-0.5,5.3-0.7c-1.9-1.4-3.9-2.9-4.7-5.1c-0.4-1.3-0.4-2.7-0.8-4c-0.4-1.5-1.3-2.9-2.2-4.2c-1.2-1.8-2.4-3.6-3.6-5.4\r\n        \t\tc-0.3-0.4-0.6-1-0.3-1.4c0.3-0.4,0.8-0.4,1.3-0.3c2.6,0.3,5.2,1,7.6,1.9c1.4,0.5,3.3,1,4.1-0.3c0.3-0.4,0.3-0.9,0.3-1.4\r\n        \t\tc0.1-1.5,0.2-2.9,0.3-4.4c0.2-3.3,0.2-7.1-2.4-9.1c-0.1-1.8,0.4-4,2-5c1.8-1.1,4.1-0.4,6.1,0.3c11.3,3.7,23.7,2.5,35.1-0.7\r\n        \t\tc2.9-0.8,5.9-1.7,8.7-0.7c1.5-3.4,3.9-6.3,6.8-8.5c1.1-0.8,2.4-1.8,2.3-3.1c0-0.5-0.2-0.9-0.3-1.3c-0.4-1.8,0.9-3.7,2.7-4\r\n        \t\tc0.7-0.1,1.3,0,2-0.2c1.6-0.4,2.5-2.1,3-3.7c0.5-1.6,0.7-3.3,1.8-4.6c1.1-1.3,2.9-1.9,4.1-3.2c2.1-2.4,1.3-6,2-9.1\r\n        \t\tc0.6-2.6,2.5-4.9,4.9-6c0.5-0.3,1.2-0.5,1.4-1.1c0.2-0.7-0.5-1.4-0.8-2.1c-0.4-0.9-0.2-2,0.5-2.7c0.6-0.6,1.4-0.8,2-1.2\r\n        \t\tc0.7-0.4,1.2-1.3,0.8-2c-0.2-0.3-0.6-0.6-0.8-0.9c-0.9-1.2,0.4-2.8,1.7-3.5c1.3-0.6,3-1.2,3.4-2.6c0.9-3.3,4.3-5.7,7.4-4.2\r\n        \t\tc2.3-2.1,0.9-6.3,2.9-8.6c0.5-0.6,1.1-1,1.6-1.5C391.4,79.6,391.2,77.4,389.9,76.3\"/> </g> <g id=ishigaki transform=\"translate(207.000000, 354.000000)\"> <path id=Fill-1_1_ class=st0 d=\"M13.7,155.1c-1.5-0.9-2.8-3.1-5.9-1.4c-1.2,0.7-1.9,3.2-2.2,4.8c-0.3,1.6-1.3,2.3-1.2,3.7\r\n        \t\tc0.1,1.4,0.4,4.9,2.5,5.3c2.2,0.4,4.7,0.2,6.5-1.1c1.8-1.3,3.3-2.9,3.2-4.8C16.6,159.5,15.2,156,13.7,155.1 M46.6,157.6\r\n        \t\tc-1.4-0.6-2.4-1.6-5.2-0.8c-1.2,0.3-4.2,1.1-4.1,1.9c0.1,0.9,0.8,2.3,2.1,1.5c1.3-0.8,2-2.1,2.9-1.6c1,0.5,2.4,0.5,3.3,0.5\r\n        \t\tS48,158.2,46.6,157.6 M42.4,88.2c0.5-0.4,0.9-1.1,0.6-1.8s-1.4-2.8-2-2c-0.8,1.1-1.2,1.8-1.1,2.8C40.1,88.3,41.8,88.6,42.4,88.2\r\n        \t\t M138.1,8.3c0.5-1.9,3-3.2,1.4-4.2c-1.6-1.1-8.2-1.8-8.2-1.8c-1.8-1.6-3.9-2.3-4.7-2.3s-2.8,1.1-2.6,2.3c0.2,1.2,0.9,7.9,0,9.5\r\n        \t\tc-0.9,1.6-3.5,3.9-4.4,5.4c-0.9,1.6-1.2,5.6-2.3,6.3c-1.1,0.7-8.8,4.9-7.9,6c0.9,1.1,5.8,5.8,5.8,5.8s1.8,3.7,0.2,4.2\r\n        \t\tc-1.6,0.5-4.2,1.8-4.4,3.5c-0.2,1.8-1.2,6-2.5,9.1c-1.2,3.2-1.9,8.1-3,7.4c-1.1-0.7-2.6-5.6-3.9-6c-1.2-0.4-3.9-3.3-5.1-1.2\r\n        \t\tc-1.2,2.1-6.7,8.3-7.9,9.8c-1.2,1.6-2.6,3.5-4,2.8c-1.4-0.7-2.3,0-2.1,2.5c0.2,2.5-0.9,3.2-1.8,4.2c-0.9,1.1-3.2,5.1-2.8,6.9\r\n        \t\tc0.4,1.8,1.4,3.5,1.8,4c0.4,0.5,1.2,4-0.4,4.7c-1.6,0.7-1.8,0.2-6,0c-4.2-0.2-5.6,0-8.2,0.4c-2.6,0.3-6.5,2.5-8.2,2.5\r\n        \t\tc-1.8,0-10.2,0.4-11.9,0c-1.8-0.4-5.3,1.6-6,3.1c-0.7,1.6-4.7,2.5-4.9,0.9c-0.2-1.6,1.9-1.1,2.3-3.2c0.4-2.1,0.7-5.1,0.7-5.1\r\n        \t\ts1.6-1.6,1.1-3.9c-0.5-2.3-2.6-5.8-6.1-6.5c-3.5-0.7-6.7-3.5-7.7-2.5c-1.1,1.1-3,3.3-0.9,3.5c2.1,0.2,6.3,0.9,5.8,2.6\r\n        \t\tc-0.5,1.8-4.4,3-4.4,4.2c0,1.2-0.9,4.2,0,5.3c0.9,1.1,2.6,3,1.4,3.7c-1.2,0.7-5.6,4.1-6.3,2.6c-0.7-1.5-1.2-4.5-2.6-4.9\r\n        \t\tc-1.4-0.4-5.3-1.4-7-1.3c-1.8,0.2-6-0.1-5.6,1.3C5,91.6,8,92.4,6.1,94c-1.9,1.6-2.3,2.3-3.3,4.2c-1.1,1.9-2.6,4-1.6,4.9\r\n        \t\tc1.1,0.9,4.7,1.8,5.4,2.6c0.7,0.9,1.1,3.9,2.3,2.8c1.2-1.1,7-7.7,7.9-8.1c0.9-0.4,3.9,1.1,4.9,1.1c1.1,0,1.6-1.9,3.5-2.1\r\n        \t\tc1.9-0.2,1.9,3,3.9,3.7c1.9,0.7,4.2,6.5,5.6,6.7c1.4,0.2,3.9,0.5,4,2.1c0.2,1.6-0.9,3.9-0.9,4.9c0,1.1,2.8,3.2,1.4,4.6\r\n        \t\tc-1.4,1.4-1.4,3-4.2,5.4c-2.8,2.5-5.1,4.7-6.7,4.4c-1.6-0.4-2.6,2.1-3.7,4.2c-1.1,2.1-1.4,5.3,0.5,5.6c1.9,0.4,9.5,1.4,9.5,1.4\r\n        \t\ts6,6,5.6,7.7c-0.4,1.8-1.8,3.7,0.2,4c1.9,0.4,5.6,1.1,6.7,2.1c1.1,1.1,7,1.6,9.8,0.9c2.8-0.7,7.2-0.7,8.2-3.7c1.1-3,0.7-8.3,3-8.4\r\n        \t\tc2.3-0.2,6.3-1.8,8.2,0.2c1.9,1.9,6.1,4.7,7.7,4.2c1.6-0.5,4.7-1.1,6.1-4.4c1.4-3.3,2.6-4.7,3.2-9c0.5-4.2,0-11.4,0.7-14.1\r\n        \t\tc0.7-2.6,3.9-9.3,2.5-12.5c-1.4-3.2-3.5-6.5-3.7-9c-0.2-2.5,1.2-1.8,2.5-3.5s2.1-2.8,0.7-4.7c-1.4-1.9-4.2-5.3-2.6-9\r\n        \t\tc1.6-3.7,7.5-10,9.5-11.2c1.9-1.2,4-1.4,5.3-2.5c1.2-1.1,1.2-4.9,1.2-4.9s-0.7-6.1,1.4-7.6c2.1-1.4,6.3-4,7.9-6.5\r\n        \t\tc1.6-2.5,5.6-5.6,4-6.9c-1.6-1.2-3.2-3-2.6-4.9c0.5-1.9,4.9-5.4,6.3-7.4c1.4-1.9,3.2-3,4.9-4.7c1.8-1.8,6.3-4.2,6.8-7.9\r\n        \t\tC138.6,15.3,137.5,10.2,138.1,8.3\"/> </g> <g id=taketomi transform=\"translate(0.000000, 429.000000)\"> <path id=Fill-1_2_ class=st0 d=\"M81.6,5.8c1.6-0.2,3.5-1.8,2.3-3s-4-2.3-4.9-1.9c-0.9,0.4-2.4,1.7-1.1,2.9\r\n        \t\tC78.8,4.6,80,6,81.6,5.8 M31.9,67.6c0.8,1.6,4.8,4.3,5.9,5.2c1.1,0.8,4.7,2.1,3.9-0.8c-0.8-2.9-1.6-3.2-3.7-4.3\r\n        \t\tc-2.1-1.2-4.6-3.9-5.1-3.9C32.2,63.7,30.5,64.9,31.9,67.6 M28.9,63.1c0.4-1.9,1.1-4.6,2.1-5.5c1.1-0.8,2.2-3-2.8-1.1\r\n        \t\tc-1.7,0.7-3.5,1.2-2.9,3.2C25.9,61.7,28.6,65,28.9,63.1 M134.2,90.5c0.7-0.8,0.2-2.3,0-3.6c-0.2-1.3,1.2,0.1,1.3-1.6\r\n        \t\tc0.1-1.8-0.9-4.1-0.9-4.1s-0.1-2.6,0.4-3.9c0.5-1.3,3.6-4.6,4.8-6.8c1.2-2.2,4.1-3.5,2-5.7c-2.1-2.2-6.4-0.1-8.4-1.7\r\n        \t\tc-2-1.6-2.5-3.4-3.2-5.1c-0.7-1.8-5.5-5.4-6.8-5.5c-1.3-0.1-4.4-0.4-5.6-1.1c-1.2-0.7-1.6,2.1-3.2,0.7c-1.6-1.4-3.4-2.9-3.2-5.4\r\n        \t\tc0.2-2.5-2.5-4.2-3.6-4.6c-1.2-0.4-2.8-0.4-3,1.5c-0.2,1.9-2.1,4-3.4,3.6c-1.3-0.4-4.2-1.8-3.9-3.2c0.4-1.4-2.3-2.7-3.4-2.2\r\n        \t\tc-1.1,0.5-4,0.3-5.1-1c-1.2-1.3-2.8-1.4-3.3,0c-0.5,1.4-0.1,4.5-1.4,4.7c-1.3,0.2-2.7-0.2-2.8,1.1c-0.1,1.3-1.2,3-2.3,2.6\r\n        \t\ts-5.4-4.5-4.3-6c1.1-1.5,2.3-4.1,1.3-5c-1.1-0.9-3.9-0.4-5.3-1.9c-1.4-1.5-0.5-3.7-1.5-4.9c-1.1-1.2-6-5.9-7.1-6.8\r\n        \t\tc-1.2-0.9-2.8-0.6-4.8-0.8c-2-0.2-4,0-4.7,1.4c-0.7,1.4-0.5,4.2,0,4c0.5-0.2,2.8,0,2.8,0s0.6,1.9,1.4,2.9c0.8,1.1,2.1,0.6,2,1.9\r\n        \t\tc-0.1,1.3-0.8,6.8,0.4,7.4c1.2,0.6,2.9,4.7,2.8,5.4c-0.1,0.7-1.9,1.3-1.9,0c0-1.3-0.8-3.9-2.5-4.1c-1.6-0.2-4.3-0.8-4.4-1.5\r\n        \t\tc-0.1-0.7,3.2-0.2,3.3-1.1c0.1-0.8,0.2-5.3-0.7-5.4c-0.9-0.1-3.3,0.8-4.7,1.3c-1.4,0.5-1.6,1.8-2.6,3.4c-0.9,1.6-2.7,1.5-2.7,3.5\r\n        \t\tc0,2,1.1,4.6,0,5.4c-1.1,0.8-3.4,0.2-4.2,0c-0.8-0.2-1.6,1.9,0,3c1.6,1.2,4,3.7,3.6,5.7c-0.4,2-1.8,3.7-2.8,4.3\r\n        \t\tc-1.1,0.6-1.8,1.9-0.1,3.3c1.6,1.5,1.9,5.8,4.1,6.4c2.2,0.6,4.4,1.8,4.8,2.7c0.4,0.9-0.9-0.4-2.6-0.7c-1.6-0.4-3.5-1.3-4.4-0.4\r\n        \t\ts-2.7,1.9-2.3,3.3c0.4,1.4,3.3,1.9,2.6,2.9c-0.7,1.1-0.9,4.9-0.9,4.9s-0.5,3.7,0.2,4.7c0.7,0.9,1.5,3.1,1.5,3.9\r\n        \t\tc0,0.8-1.1,2.4-1.4,3.6c-0.4,1.2-0.7-2.3-0.7-3.6c0-1.3-0.1-3.4-1.3-4.1c-1.2-0.7,0.4,0.8-1.2,1.5c-1.6,0.7-1.5-0.8-1.9-2.1\r\n        \t\tc-0.4-1.3-0.9-1.1-1.1-2.5c-0.1-1.4,0.1-2.1-0.7-2.1c-0.8,0-2.2,1.8-3.2,0.6c-0.9-1.2-0.1-2.8,0-4.3c0.1-1.5,0.1-3.3-1.1-3\r\n        \t\tc-1.2,0.2-3,1.2-3.4,1.8c-0.4,0.6-2,1.3-2.6,3c-0.6,1.6-2,3.1-2.6,1.4c-0.6-1.7,0.4-3.9-1.2-4.4c-1.5-0.5-1.9-2.2-1.8-3.6\r\n        \t\tc0.1-1.5-1.5-1.8-2.1-0.7c-0.6,1.2-2.3,5.2,0,7c2.3,1.9,3.6,4.3,3.6,5.8c0,1.6,1.8,3.5,1.8,3.8c0,0.2-3.9,3.3-4.2,2\r\n        \t\tc-0.4-1.3,1.2-2.4,0.4-3.9c-0.8-1.5-2.9-3.3-4.2-3.4c-1.3,0-2.6-1.2-3.3-2.1c-0.7-0.9-2.8-1.2-3.4,0.4c-0.6,1.5-1.2,4.3-0.6,4.6\r\n        \t\tc0.6,0.2,1.8,0.1,1.5,1.6c-0.2,1.5-1.3,2.6,0.1,3.5s1.4,2,0.5,2.2c-0.9,0.2-2.1,0.4-2.3-0.7c-0.2-1.1-0.9-2-2-1.1\r\n        \t\tc-1.1,0.9-1.8,0.6-2.7-0.5c-0.9-1.1-3.9,1.6-4.3,1.9c-0.5,0.2,0.1,1.8,1.1,3.5c0.9,1.8,6.5,9.7,8.1,10.2s4,1.9,5.1,1.1\r\n        \t\tc1.2-0.8,2.9-0.6,4.3,0.2c1.4,0.8,4.9,2,6.4,2c1.5,0,4.1-1.5,4.2-3.9c0.1-2.3-0.1-5.5,0-6.6c0.1-1.1,3.4-1.6,5.8,0.5\r\n        \t\tc2.5,2.1,8.3,7.3,10.9,8.4c2.6,1.2,6.1,0.8,8.8,1.8c2.7,0.9,2.9,0.8,5.7,1.1c2.8,0.2,8.6,3,11.6,3.4c2.9,0.4,6.5,0.4,9.6-0.2\r\n        \t\tc3-0.6,9.1-0.4,11.2,1.6c2,2,6.2,6.6,8.9,6.9c2.7,0.4,7,0.2,8.1,0c1.1-0.2,1.6-1.9,2-4.5c0.4-2.6,2.7-3.5,1.5-4.8\r\n        \t\tc-1.2-1.3-4-1.6-4.3-3c-0.4-1.4-0.4-1.9-1.6-3.4c-1.3-1.5-3.2-2.9-5.7-2.9s-0.1-1.3,1.6-1.5c1.8-0.2,4.9,1.6,5.5,3.2\r\n        \t\tc0.6,1.5,3,3.7,4.2,3.6c1.2-0.1,5,0.1,6.1,1.2c1.1,1.1,2.2,4.3,3.4,2.2c1.2-2.1,1.2-3.3,0.6-5.8c-0.6-2.6,0.4-4.2-0.8-6.1\r\n        \t\tc-1.2-1.9,0-8.7,0-8.7s3.7,0.8,5,0s0-6,0-6.9c0-0.9,3.2-0.8,3.7,0C131.7,88.4,133.5,91.3,134.2,90.5 M134.6,144.8\r\n        \t\tc-1.1,0.6-3.3,2-1.8,3.4c1.4,1.3,3.9,3.4,5.3,2.7c1.4-0.7,3.2-3.3,1.5-4.7C138,144.8,135.6,144.2,134.6,144.8 M144.9,132.7\r\n        \t\tc-1.1,1.3-3.2,4.5-4,5.9c-0.8,1.4-0.9,3.4,0,3.5c0.9,0.1,4.3-1.9,5.3-3c0.9-1.2,3-3.6,2.5-4.7C148.3,133.3,146.3,131,144.9,132.7\r\n        \t\t M186.9,128.7c-2.6-0.4-6,1.5-7.5,0.8c-1.5-0.7-3.5-1.6-3.5-1.6c-2.8-1.2-4.7-0.8-6.1,0c-1.4,0.8-3,3.2-2.5,4.5\r\n        \t\tc0.6,1.3,3.2,4.1,4.2,6.1c1.1,2,0.7,4.5,3.5,4.6c2.8,0.1,5.7,0,8.3-1.5c2.6-1.5,4.4-3.7,4.4-7.1S189.5,129.1,186.9,128.7\r\n        \t\t M174.2,65.9c0.3-1.1-0.5-3.6-3-2.6c-0.6,0.2-0.4,2.2,0,2.6C171.7,66.4,174,67.1,174.2,65.9 M169.3,86.7c1.8-0.5,3.8-0.5,4-2.4\r\n        \t\tc0.3-1.8-1.5-3-3.6-4.2c-2.1-1.2-3.1-3.4-2.4-4.4c0.7-1,0.9-2.1-0.3-2.7c-1.1-0.6-4.8-3.3-7.7-3.3c-0.7,0-3.8,1.1-4.6,2.1\r\n        \t\tc-0.9,1-1.1,2.2,0,3.3c1.1,1.1,2.6,2.6,1.4,3.1c-1.2,0.5-5.1,1.8-6.1,2c-1.1,0.2-2.1,2-0.6,2.1c1.5,0.1,6.6-1.2,7.5-0.7\r\n        \t\ts7.5,0.1,8.3,2C166.2,85.3,167.6,87.2,169.3,86.7\"/> </g> <template v-for=\"(item, index) in videoCulturePins\"> <g class=\"map__pins culturePins\" :transform=item.pin.matrix v-on:click=\"playVideo(item, $event)\"> <path fill=#E9464C class=st0 d=\"M26.5,5.8c-2.2-2.2-5.1-3.4-8.2-3.4c-3.1,0-6,1.2-8.2,3.4c-4,4-4.5,11.6-1.1,16.2l9.3,13.4L27.6,22\r\n          \t\t\t\tC31,17.4,30.5,9.8,26.5,5.8z\"/> <path fill=#FFFFFF class=st1 d=\"M22.1,14.1l-5.8-3.7c-0.2-0.1-0.4-0.1-0.5-0.1c-0.6,0-0.6,0.5-0.6,0.6v7.5c0,0.1,0,0.6,0.6,0.6\r\n          \t\tc0.2,0,0.4,0,0.5-0.1l5.8-3.7c0.5-0.3,0.4-0.6,0.4-0.6S22.5,14.4,22.1,14.1z\"/> </g> </template> <template v-for=\"(item, index) in videoLocationsPins\"> <g class=\"map__pins locationsPins\" :transform=item.pin.matrix v-on:click=\"playVideo(item, $event)\"> <path fill=#13B8D7 class=st0 d=\"M26.5,5.8c-2.2-2.2-5.1-3.4-8.2-3.4c-3.1,0-6,1.2-8.2,3.4c-4,4-4.5,11.6-1.1,16.2l9.3,13.4L27.6,22\r\n          \t\t\t\tC31,17.4,30.5,9.8,26.5,5.8z\"/> <path fill=#FFFFFF class=st1 d=\"M22.1,14.1l-5.8-3.7c-0.2-0.1-0.4-0.1-0.5-0.1c-0.6,0-0.6,0.5-0.6,0.6v7.5c0,0.1,0,0.6,0.6,0.6\r\n          \t\tc0.2,0,0.4,0,0.5-0.1l5.8-3.7c0.5-0.3,0.4-0.6,0.4-0.6S22.5,14.4,22.1,14.1z\"/> </g> </template> <template v-for=\"(item, index) in videoFoodPins\"> <g class=\"map__pins foodPins\" :transform=item.pin.matrix v-on:click=\"playVideo(item, $event)\"> <path fill=#F8C630 class=st0 d=\"M26.5,5.8c-2.2-2.2-5.1-3.4-8.2-3.4c-3.1,0-6,1.2-8.2,3.4c-4,4-4.5,11.6-1.1,16.2l9.3,13.4L27.6,22\r\n          \t\t\t\tC31,17.4,30.5,9.8,26.5,5.8z\"/> <path fill=#FFFFFF class=st1 d=\"M22.1,14.1l-5.8-3.7c-0.2-0.1-0.4-0.1-0.5-0.1c-0.6,0-0.6,0.5-0.6,0.6v7.5c0,0.1,0,0.6,0.6,0.6\r\n          \t\tc0.2,0,0.4,0,0.5-0.1l5.8-3.7c0.5-0.3,0.4-0.6,0.4-0.6S22.5,14.4,22.1,14.1z\"/> </g> </template> <template v-for=\"(item, index) in videoNaturePins\"> <g class=\"map__pins naturePins\" :transform=item.pin.matrix v-on:click=\"playVideo(item, $event)\"> <path fill=#51BBB4 class=st0 d=\"M26.5,5.8c-2.2-2.2-5.1-3.4-8.2-3.4c-3.1,0-6,1.2-8.2,3.4c-4,4-4.5,11.6-1.1,16.2l9.3,13.4L27.6,22\r\n          \t\t\t\tC31,17.4,30.5,9.8,26.5,5.8z\"/> <path fill=#FFFFFF class=st1 d=\"M22.1,14.1l-5.8-3.7c-0.2-0.1-0.4-0.1-0.5-0.1c-0.6,0-0.6,0.5-0.6,0.6v7.5c0,0.1,0,0.6,0.6,0.6\r\n          \t\tc0.2,0,0.4,0,0.5-0.1l5.8-3.7c0.5-0.3,0.4-0.6,0.4-0.6S22.5,14.4,22.1,14.1z\"/> </g> </template> <template v-for=\"(item, index) in culturePins\"> <g class=\"map__pins culturePins\" :transform=item.pin.matrix v-on:click=testClick> <path fill=#E9464C class=st0 d=\"M26.2 4.9C24 2.7 21.1 1.5 18 1.5c-3.1 0-6 1.2-8.2 3.4-4 4-4.5 11.6-1.1 16.2L18 34.5l9.2-13.4c3.5-4.6 3-12.2-1-16.2z\"/> <path fill=#FFFFFF class=st1 d=\"M18 8.9c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4c-.1-2.2 1.7-4 4-4z\"/> </g> </template> <template v-for=\"(item, index) in foodPins\"> <g class=\"map__pins foodPins\" :transform=item.pin.matrix v-on:click=openModal(item)> <path fill=#F8C630 class=st0 d=\"M26.2 4.9C24 2.7 21.1 1.5 18 1.5c-3.1 0-6 1.2-8.2 3.4-4 4-4.5 11.6-1.1 16.2L18 34.5l9.2-13.4c3.5-4.6 3-12.2-1-16.2z\"/> <path fill=#FFFFFF class=st1 d=\"M18 8.9c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4c-.1-2.2 1.7-4 4-4z\"/> </g> </template> <template v-for=\"(item, index) in locationsPins\"> <g class=\"map__pins locationsPins\" :transform=item.pin.matrix v-on:click=openModal(item)> <path fill=#13B8D7 class=st0 d=\"M26.2 4.9C24 2.7 21.1 1.5 18 1.5c-3.1 0-6 1.2-8.2 3.4-4 4-4.5 11.6-1.1 16.2L18 34.5l9.2-13.4c3.5-4.6 3-12.2-1-16.2z\"/> <path fill=#FFFFFF class=st1 d=\"M18 8.9c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4c-.1-2.2 1.7-4 4-4z\"/> </g> </template> <template v-for=\"(item, index) in naturePins\"> <g class=\"map__pins naturePins\" :transform=item.pin.matrix v-on:click=openModal(item)> <path fill=#51BBB4 class=st0 d=\"M26.2 4.9C24 2.7 21.1 1.5 18 1.5c-3.1 0-6 1.2-8.2 3.4-4 4-4.5 11.6-1.1 16.2L18 34.5l9.2-13.4c3.5-4.6 3-12.2-1-16.2z\"/> <path fill=#FFFFFF class=st1 d=\"M18 8.9c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4c-.1-2.2 1.7-4 4-4z\"/> </g> </template> <template v-for=\"(group, index) in groupMarkers\"> <g :id=\"'group_marker_' + group.id\" class=\"map__pins groupPins\" :transform=group.matrix v-on:click=\"showGroup(group, $event)\"> <path d=\"M26.9098621,4.617 C23.9328621,1.64 19.9738621,0 15.7638621,0 C11.5528621,0 7.59486212,1.64 4.61686212,4.617 C-0.892137879,10.126 -1.57713788,20.491 3.13486212,26.772 L15.7638621,45.01 L28.3738621,26.797 C33.1038621,20.491 32.4198621,10.126 26.9098621,4.617 L26.9098621,4.617 Z\" id=Stroke-7 fill=#354D51></path> <path d=\"M15.45,6 C21.221,6 25.9,10.679 25.9,16.45 C25.9,22.221 21.221,26.9 15.45,26.9 C9.679,26.9 5,22.221 5,16.45 C5,10.679 9.679,6 15.45,6 L15.45,6 Z\" id=Stroke-3 stroke=#FFFFFF stroke-width=2 opacity=0.200000003></path> <text x=15 y=21 font-family=Karla font-size=15 fill=white text-anchor=middle>{{groupPins[group.id] ? groupPins[group.id].length : 0}}</text> </g> </template> </svg> </div> <ul class=map__categories> <li class=view>View:</li> <li class=all :class=\"{isActive: activeCategory == ''}\" v-on:click=\"setCategory('')\">All</li> <li class=culture :class=\"{isActive: activeCategory == 'culturePins'}\" v-on:click=\"setCategory('culturePins')\">Culture</li> <li class=food :class=\"{isActive: activeCategory == 'foodPins'}\" v-on:click=\"setCategory('foodPins')\">Food & Drink</li> <li class=nature :class=\"{isActive: activeCategory == 'naturePins'}\" v-on:click=\"setCategory('naturePins')\">Nature</li> <li class=locations :class=\"{isActive: activeCategory == 'locationsPins'}\" v-on:click=\"setCategory('locationsPins')\">Locations</li> </ul> <div class=map__meta> <span class=map__disclaimer>*This map is not to scale.</span> <a class=map__scale href=https://www.google.co.jp/maps/@26.44317,127.9368912,10.5z target=_blank> <img :src=\"'images/map_toscale.png'\" alt=\"\"/> <span>View Google Maps</span> </a> </div> <div class=map__group-modal v-for=\"(group, key) in groupPins\" :style=\"{left: activePin.x + 'px', top: activePin.y + 'px'}\" :class=\"{isActive: activePin.id == key}\"> <ul> <li v-for=\"pin in group\" :class=pin.category_class v-on:click=handlePopup(pin)> <svg xmlns=http://www.w3.org/2000/svg> <circle cx=10 cy=10 r=9 stroke=white stroke-width=2 /> <polygon v-show=pin.section points=\"25,10 10,0 10,20\" transform=\"scale(0.45), translate(7,11)\" style=fill:#fff></polygon> </svg> </li> </ul> </div> </div> <div class=map__slim> <div class=map__slim-map> <img :src=\"'images/okinawa-small.png'\" alt=\"\"/> </div> <div class=\"map__slim-groups -culture\" :class=\"{isActive: activeCategory == 'culture'}\" v-on:click=\"toggleCategory('culture')\"> <h4> <img :src=\"'images/category-culture.svg'\" alt=\"\"/> <span>Culture</span></h4> <ul> <li v-for=\"item in getContentCategory('culture')\" v-on:click=handlePopup(item) :class=\"{video: item.section ? true : false}\"> {{item.title}} </li> </ul> </div> <div class=\"map__slim-groups -food\" :class=\"{isActive: activeCategory == 'food'}\" v-on:click=\"toggleCategory('food')\"> <h4> <img :src=\"'images/category-food.svg'\" alt=\"\"/> <span>Food & Drink</span></h4> <ul> <li v-for=\"item in getContentCategory('food')\" v-on:click=handlePopup(item) :class=\"{video: item.section ? true : false}\"> {{item.title}} </li> </ul> </div> <div class=\"map__slim-groups -nature\" :class=\"{isActive: activeCategory == 'nature'}\" v-on:click=\"toggleCategory('nature')\"> <h4> <img :src=\"'images/category-nature.svg'\" alt=\"\"/> <span>Nature</span></h4> <ul> <li v-for=\"item in getContentCategory('nature')\" v-on:click=handlePopup(item) :class=\"{video: item.section ? true : false}\"> {{item.title}} </li> </ul> </div> <div class=\"map__slim-groups -locations\" :class=\"{isActive: activeCategory == 'locations'}\" v-on:click=\"toggleCategory('locations')\"> <h4> <img :src=\"'images/category-locations.svg'\" alt=\"\"/> <span>Locations</span></h4> <ul> <li v-for=\"item in getContentCategory('locations')\" v-on:click=handlePopup(item) :class=\"{video: item.section ? true : false}\"> {{item.title}} </li> </ul> </div> </div> <modal v-for=\"modal in modals\" :modal=modal :is-active=\"showModal && modalId == modal.gid\" :close-modal=closeModal></modal> <slot></slot> </div> ";

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = "<div class=modal v-bind:class={isActive:isActive}> <div class=modal__inner> <ul class=modal__buttons> <li> <button class=modal__close v-on:click=closeThisModal><img :src=\"'images/close.svg'\" alt=\"\"/></button> </li> <li :class=\"{showSocials: showSocials}\"> <button class=modal__share v-on:click=\"showSocials = !showSocials\"><img :src=\"'images/share.svg'\" alt=\"\"/></button> <div class=addthis_toolbox> <a class=addthis_button_facebook></a> <a class=addthis_button_twitter></a> <a class=addthis_button_email></a> </div> </li> </ul> <div class=modal__category :class=modal.category_class> <img :src=\"'images/category-' + modal.category_class + '.svg'\" alt=\"\"/> <span>{{modal.category}}</span> </div> <h3 class=modal__title>{{modal.title}}</h3> <p class=modal__subtitle>{{modal.subtitle}}</p> <div class=\"modal__images slider js_slider\"> <div class=\"frame js_frame\"> <ul class=\"slides js_slides\"> <li v-for=\"image in modal.images\" class=\"js_slide modal__image\"> <img :src=\"isActive ? image : ''\" alt=\"\"/> </li> </ul> </div> </div> <ul class=modal__dots> <li v-for=\"(image, index) in modal.images\" :class=\"{isActive:index== currentSlide}\" v-on:click=slideTo(index)></li> </ul> <h4 class=modal__intro>{{modal.intro}}</h4> <p class=modal__body> {{modal.body}} </p> <div class=modal__location v-if=modal.location> <h4>Getting there</h4> <a :href=modal.location.link target=_blank> <img :src=modal.location.img alt=\"\"/> </a> <ul> <li> <strong>Directions</strong> <p>{{modal.location.address}}</p> <p v-if=modal.location.directions> {{modal.location.directions}} </p> <p v-if=modal.location.hours> Hours: {{modal.location.hours}} </p> </li> <li v-if=modal.location.website> <a target=_blank :href=modal.location.website>{{modal.location.website}}</a> </li> </ul> <p class=modal__location-link> <a :href=modal.location.link target=_blank>Open in Google Maps</a> </p> </div> </div> </div> ";

/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports = "<div class=pre-loader> <div class=pre-loader__inner> <div class=pre-loader__text> <img :src=\"'images/separator.svg'\" alt=\"\"/> <p> Uncover a destination <br> like no other while discovering <br> the secret to longevity. </p> <img :src=\"'images/separator.svg'\" alt=\"\"/> </div> <div class=pre-loader__canvas> <canvas resize=true hidpi=off id=canvas-1></canvas> <div class=canvas-after>&nbsp;</div> </div> </div> </div> ";

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports = "<div class=videos> <div class=videos__prompt :class=\"{seenPrompt: currentVideo.seenPrompt, noPrompt: noPrompt}\"> <span class=videos__prompt-spot></span> <p> During the video look for these dots.<br> Click them to discover more. </p> </div> <div class=videos__inner> <div class=videos__playpause v-bind:class=\"{isPlaying: videoPlaying, isTouchDevice: isTouchDevice}\"><span></span></div> <div class=videos__outros v-bind:class=\"{isEnding: (currentVideo.duration - currentTime < 6) && currentVideo.duration > 0}\"> <ul> <li class=videos__outro v-on:click=replayVideo()> <span>Watch Again</span> </li> <li class=videos__outro v-for=\"vid in otherVideos\" :class=vid.name> <a :href=\"'#/videos/' + vid.id\"> <span>Watch {{vid.title}}</span> </a> </li> </ul> </div> <div class=videos__frame> <div class=videos__frame-inner v-show=videoURL> <iframe id=ytframe width=960 height=720 enablejsapi=true :src=videoURL frameborder=0></iframe> </div> </div> <div class=videos__hotspots-wrapper> <div class=videos__hotspots v-for=\"(spot, index) in modals\" v-on:click=\"openModal(spot, true)\" v-bind:style=\"{'left': timeToOffset(spot.section.time)}\" :class=\"{isActive: currentTime >= spot.section.time &&  currentTime < spot.section.time + 10 && !showModal}\"> <img class=videos__hotspot-hint :src=\"'images/hint.png'\" v-if=\"index == 0\"> <span class=videos__hotspot></span> </div> </div> <div class=videos__progress :class=\"{hideBar: showModal || videoEnded, hintPoint: hintPoint}\"> <ul class=videos__progress-points> <li v-for=\"modal in modals\" v-bind:style=\"{left: timeToOffset(modal.section.time)}\" v-on:click=openModal(modal) class=videos__progress-point v-bind:class=\"{isVisible: timeToOffset(modal.section.time) != '-100%'}\"> <i><img :src=modal.section.icon alt=\"\"/></i> </li> </ul> <div class=videos__progress-seek v-on:click=scrobble($event)> <span :style=\"{ width: progressBar }\" class=videos__progress-bar></span> </div> </div> <modal v-for=\"modal in modals\" :modal=modal :is-active=\"showModal && modalTime == modal.section.time\" :close-modal=closeModal></modal> </div> <slot></slot> </div> ";

/***/ }
]);


// WEBPACK FOOTER //
// main.js